/* tslint:disable */
/* eslint-disable */
/**
 * Velys Insights API Gateway Management
 * Velys Insights managing Lambda configurations and routes. Handling file uploads, downloading, patient/file retrieval.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: daniela@docspera.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'description_long'?: string;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'status': ActionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'delta_days_from_surgery': string;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof Action
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {Array<Asset>}
     * @memberof Action
     */
    'assets'?: Array<Asset>;
    /**
     * 
     * @type {boolean}
     * @memberof Action
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'execution_date'?: string;
    /**
     * Track Item origination
     * @type {string}
     * @memberof Action
     */
    'source'?: string | null;
}

export const ActionStatusEnum = {
    Completed: 'completed',
    Pending: 'pending',
    Confirmed: 'confirmed'
} as const;

export type ActionStatusEnum = typeof ActionStatusEnum[keyof typeof ActionStatusEnum];

/**
 * 
 * @export
 * @interface ActionUpdateStatusRequest
 */
export interface ActionUpdateStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionUpdateStatusRequest
     */
    'status': ActionUpdateStatusRequestStatusEnum;
}

export const ActionUpdateStatusRequestStatusEnum = {
    Completed: 'completed',
    Pending: 'pending',
    Confirmed: 'confirmed'
} as const;

export type ActionUpdateStatusRequestStatusEnum = typeof ActionUpdateStatusRequestStatusEnum[keyof typeof ActionUpdateStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface AdminPasswordReset200Response
 */
export interface AdminPasswordReset200Response {
    /**
     * 
     * @type {string}
     * @memberof AdminPasswordReset200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AdminPasswordResetRequest
 */
export interface AdminPasswordResetRequest {
    /**
     * New password for the user. Must meet Cognito password policy requirements (12+ chars, uppercase, lowercase, number, symbol)
     * @type {string}
     * @memberof AdminPasswordResetRequest
     */
    'new_password': string;
}
/**
 * 
 * @export
 * @interface Assessment
 */
export interface Assessment {
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'uri': string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'delta_days_from_surgery': string;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof Assessment
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {AssessmentPerformanceWindow}
     * @memberof Assessment
     */
    'performance_window': AssessmentPerformanceWindow;
    /**
     * 
     * @type {boolean}
     * @memberof Assessment
     */
    'required': boolean;
}
/**
 * 
 * @export
 * @interface AssessmentPerformanceWindow
 */
export interface AssessmentPerformanceWindow {
    /**
     * 
     * @type {string}
     * @memberof AssessmentPerformanceWindow
     */
    'days_pre': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPerformanceWindow
     */
    'days_post': string;
}
/**
 * 
 * @export
 * @interface AssessmentPlan
 */
export interface AssessmentPlan {
    /**
     * 
     * @type {string}
     * @memberof AssessmentPlan
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPlan
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPlan
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPlan
     */
    'provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentPlan
     */
    'uri'?: string;
}
/**
 * 
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'asset_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    's3_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'created_at'?: string;
}
/**
 * 
 * @export
 * @interface BespokeTemplate
 */
export interface BespokeTemplate {
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'care_plan_name': string;
    /**
     * Enrollment Unique ID set by system
     * @type {string}
     * @memberof BespokeTemplate
     */
    'care_plan_id'?: string;
    /**
     * Version of the care plan
     * @type {string}
     * @memberof BespokeTemplate
     */
    'version'?: string;
    /**
     * Language of the care plan
     * @type {string}
     * @memberof BespokeTemplate
     */
    'language'?: string;
    /**
     * All the tags on a careplan
     * @type {Array<string>}
     * @memberof BespokeTemplate
     */
    'tags'?: Array<string>;
    /**
     * Date when careplan was created
     * @type {string}
     * @memberof BespokeTemplate
     */
    'create_date'?: string;
    /**
     * Surgery Date
     * @type {string}
     * @memberof BespokeTemplate
     */
    'surgery_date': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'status'?: BespokeTemplateStatusEnum;
    /**
     * 
     * @type {BespokeTemplateInfo}
     * @memberof BespokeTemplate
     */
    'info'?: BespokeTemplateInfo;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'patient_id': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplate
     */
    'timezone': string;
    /**
     * 
     * @type {Array<Action>}
     * @memberof BespokeTemplate
     */
    'actions': Array<Action>;
    /**
     * 
     * @type {Array<AssessmentPlan>}
     * @memberof BespokeTemplate
     */
    'assessment_plans': Array<AssessmentPlan>;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof BespokeTemplate
     */
    'assessments': Array<Assessment>;
    /**
     * 
     * @type {Array<Broadcast>}
     * @memberof BespokeTemplate
     */
    'broadcasts': Array<Broadcast>;
    /**
     * 
     * @type {Array<Event>}
     * @memberof BespokeTemplate
     */
    'events': Array<Event>;
}

export const BespokeTemplateStatusEnum = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type BespokeTemplateStatusEnum = typeof BespokeTemplateStatusEnum[keyof typeof BespokeTemplateStatusEnum];

/**
 * 
 * @export
 * @interface BespokeTemplateInfo
 */
export interface BespokeTemplateInfo {
    /**
     * 
     * @type {BespokeTemplateInfoOffice}
     * @memberof BespokeTemplateInfo
     */
    'office': BespokeTemplateInfoOffice;
    /**
     * 
     * @type {BespokeTemplateInfoPhysician}
     * @memberof BespokeTemplateInfo
     */
    'physician': BespokeTemplateInfoPhysician;
}
/**
 * 
 * @export
 * @interface BespokeTemplateInfoOffice
 */
export interface BespokeTemplateInfoOffice {
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoOffice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoOffice
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoOffice
     */
    'location': string;
}
/**
 * 
 * @export
 * @interface BespokeTemplateInfoPhysician
 */
export interface BespokeTemplateInfoPhysician {
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoPhysician
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoPhysician
     */
    'npi': string;
    /**
     * 
     * @type {string}
     * @memberof BespokeTemplateInfoPhysician
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Broadcast
 */
export interface Broadcast {
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'category': BroadcastCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'description'?: string;
    /**
     * 
     * @type {Asset}
     * @memberof Broadcast
     */
    'asset'?: Asset;
    /**
     * 
     * @type {Array<Asset>}
     * @memberof Broadcast
     */
    'assets'?: Array<Asset>;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'delta_days_from_surgery': string;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'execution_date'?: string;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof Broadcast
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {string}
     * @memberof Broadcast
     */
    'status'?: string;
}

export const BroadcastCategoryEnum = {
    Exercise: 'Exercise',
    Education: 'Education'
} as const;

export type BroadcastCategoryEnum = typeof BroadcastCategoryEnum[keyof typeof BroadcastCategoryEnum];

/**
 * 
 * @export
 * @interface BulkDeleteItemsRequest
 */
export interface BulkDeleteItemsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteItemsRequest
     */
    'actions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteItemsRequest
     */
    'broadcasts': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteItemsRequest
     */
    'events': Array<string>;
}
/**
 * 
 * @export
 * @interface CreatePatientEnrollmentRequest
 */
export interface CreatePatientEnrollmentRequest {
    /**
     * Unique patient identifier
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'patient_id': string;
    /**
     * Name of the surgical procedure
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'procedure_name': string;
    /**
     * Surgery date (YYYY-MM-DD)
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'surgery_date': string;
    /**
     * Name of the surgery location
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'location_name': string;
    /**
     * User ID (Provider User ID)
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'surgeon_id': string;
    /**
     * Surgeon Full Name
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'surgeon_name': string;
    /**
     * Surgeon NPI
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'surgeon_npi': string;
    /**
     * Unique identifier for the care plan template
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'template_id': string;
    /**
     * Display name of the care plan template
     * @type {string}
     * @memberof CreatePatientEnrollmentRequest
     */
    'care_plan_name': string;
}
/**
 * 
 * @export
 * @interface DownloadFiles200Response
 */
export interface DownloadFiles200Response {
    /**
     * 
     * @type {string}
     * @memberof DownloadFiles200Response
     */
    'message'?: string;
    /**
     * True if email was sent, false if not
     * @type {boolean}
     * @memberof DownloadFiles200Response
     */
    'notificationSent'?: boolean;
}
/**
 * 
 * @export
 * @interface DownloadFilesLink200Response
 */
export interface DownloadFilesLink200Response {
    /**
     * The pre-signed URL to upload the ZIP file
     * @type {string}
     * @memberof DownloadFilesLink200Response
     */
    'pre_signed_url'?: string;
}
/**
 * 
 * @export
 * @interface DownloadRequest
 */
export interface DownloadRequest {
    /**
     * 
     * @type {DownloadRequestUpload}
     * @memberof DownloadRequest
     */
    'upload': DownloadRequestUpload;
}
/**
 * 
 * @export
 * @interface DownloadRequestUpload
 */
export interface DownloadRequestUpload {
    /**
     * Organization unique identifier
     * @type {string}
     * @memberof DownloadRequestUpload
     */
    'org_id': string;
}
/**
 * 
 * @export
 * @interface Enrollment
 */
export interface Enrollment {
    /**
     * Enrollment Unique ID
     * @type {string}
     * @memberof Enrollment
     */
    'enrollment_id': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof Enrollment
     */
    'organization_id'?: string;
    /**
     * Patient Unique ID
     * @type {string}
     * @memberof Enrollment
     */
    'patient_id'?: string;
    /**
     * Procedure name
     * @type {string}
     * @memberof Enrollment
     */
    'procedure_name': string;
    /**
     * Surgery Date
     * @type {string}
     * @memberof Enrollment
     */
    'surgery_date': string;
    /**
     * Surgeon NPI
     * @type {string}
     * @memberof Enrollment
     */
    'surgeon_npi'?: string;
    /**
     * Surgeon ID
     * @type {string}
     * @memberof Enrollment
     */
    'surgeon_id': string;
    /**
     * Surgeon Full Name
     * @type {string}
     * @memberof Enrollment
     */
    'surgeon_name'?: string;
    /**
     * Surgery Location Name
     * @type {string}
     * @memberof Enrollment
     */
    'location_name': string;
    /**
     * Careplan Template ID
     * @type {string}
     * @memberof Enrollment
     */
    'template_id': string;
    /**
     * Path to get Careplan details
     * @type {string}
     * @memberof Enrollment
     */
    'url'?: string;
    /**
     * S3 Version ID
     * @type {string}
     * @memberof Enrollment
     */
    's3_version_id'?: string;
    /**
     * Patient Pain value from assessment
     * @type {boolean}
     * @memberof Enrollment
     */
    'high_pain': boolean;
    /**
     * Incision photo flag alert
     * @type {boolean}
     * @memberof Enrollment
     */
    'incision_photo_flag'?: boolean;
    /**
     * Path to get vras case data
     * @type {string}
     * @memberof Enrollment
     */
    'vras_case_link': string;
    /**
     * Enrollment status
     * @type {string}
     * @memberof Enrollment
     */
    'status': EnrollmentStatusEnum;
    /**
     * Name of the careplan
     * @type {string}
     * @memberof Enrollment
     */
    'care_plan_name'?: string;
}

export const EnrollmentStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Pending: 'PENDING'
} as const;

export type EnrollmentStatusEnum = typeof EnrollmentStatusEnum[keyof typeof EnrollmentStatusEnum];

/**
 * 
 * @export
 * @interface EnrollmentActionItem
 */
export interface EnrollmentActionItem {
    /**
     * Unique identifier for the action
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'action_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'enrollment_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'patient_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'execution_arn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'schedule_arn'?: string | null;
    /**
     * ISO date-time of when the action is executed or due
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'execution_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'description_long'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'status': EnrollmentActionItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentActionItem
     */
    'required': boolean;
    /**
     * Number of days offset from the surgery date
     * @type {number}
     * @memberof EnrollmentActionItem
     */
    'delta_days_from_surgery': number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'completed_at'?: string | null;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof EnrollmentActionItem
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {Array<Asset>}
     * @memberof EnrollmentActionItem
     */
    'assets'?: Array<Asset>;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'uri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'updated_at'?: string | null;
    /**
     * Track Item origination
     * @type {string}
     * @memberof EnrollmentActionItem
     */
    'source'?: string | null;
}

export const EnrollmentActionItemStatusEnum = {
    Completed: 'completed',
    Pending: 'pending',
    Confirmed: 'confirmed'
} as const;

export type EnrollmentActionItemStatusEnum = typeof EnrollmentActionItemStatusEnum[keyof typeof EnrollmentActionItemStatusEnum];

/**
 * 
 * @export
 * @interface EnrollmentEdit
 */
export interface EnrollmentEdit {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'enrollment_id'?: string;
    /**
     * Unique identifier for this edit
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'edit_id': string;
    /**
     * Current status of the edit
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'status'?: EnrollmentEditStatusEnum;
    /**
     * ISO 8601 timestamp when the edit was created
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'created_at'?: string;
    /**
     * ISO 8601 timestamp when the edit was processed
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'processed_at'?: string;
    /**
     * Error message if status is \'failed\'
     * @type {string}
     * @memberof EnrollmentEdit
     */
    'error_message'?: string;
}

export const EnrollmentEditStatusEnum = {
    Processing: 'processing',
    Uploaded: 'uploaded',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type EnrollmentEditStatusEnum = typeof EnrollmentEditStatusEnum[keyof typeof EnrollmentEditStatusEnum];

/**
 * 
 * @export
 * @interface EnrollmentEditUploadResponse
 */
export interface EnrollmentEditUploadResponse {
    /**
     * Unique identifier for this edit
     * @type {string}
     * @memberof EnrollmentEditUploadResponse
     */
    'edit_id': string;
    /**
     * Pre-signed S3 URL for uploading enrollment edit JSON
     * @type {string}
     * @memberof EnrollmentEditUploadResponse
     */
    'upload_url': string;
    /**
     * ISO 8601 timestamp when the upload URL expires
     * @type {string}
     * @memberof EnrollmentEditUploadResponse
     */
    'expires_at': string;
    /**
     * Additional headers to be used in the edit request
     * @type {{ [key: string]: string; }}
     * @memberof EnrollmentEditUploadResponse
     */
    'additional_headers'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Machine-readable error code
     * @type {string}
     * @memberof ErrorResponse
     */
    'error_code'?: ErrorResponseErrorCodeEnum;
    /**
     * Human-readable error message
     * @type {string}
     * @memberof ErrorResponse
     */
    'message'?: string;
}

export const ErrorResponseErrorCodeEnum = {
    InvalidPasswordFormat: 'INVALID_PASSWORD_FORMAT',
    UserNotFound: 'USER_NOT_FOUND',
    InsufficientPermissions: 'INSUFFICIENT_PERMISSIONS',
    NotAdmin: 'NOT_ADMIN',
    CognitoError: 'COGNITO_ERROR'
} as const;

export type ErrorResponseErrorCodeEnum = typeof ErrorResponseErrorCodeEnum[keyof typeof ErrorResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'delta_days_from_surgery': string;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof Event
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'event_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'execution_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface GenericTemplate
 */
export interface GenericTemplate {
    /**
     * Unique identifier for the care plan template
     * @type {string}
     * @memberof GenericTemplate
     */
    'id': string;
    /**
     * Display name of the care plan template
     * @type {string}
     * @memberof GenericTemplate
     */
    'name': string;
    /**
     * s3_url from generic care plan template details
     * @type {string}
     * @memberof GenericTemplate
     */
    's3_url'?: string;
}
/**
 * 
 * @export
 * @interface GetAssessment200Response
 */
export interface GetAssessment200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'uri': string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'delta_days_from_surgery': string;
    /**
     * 
     * @type {Array<Reminder>}
     * @memberof GetAssessment200Response
     */
    'reminders'?: Array<Reminder>;
    /**
     * 
     * @type {AssessmentPerformanceWindow}
     * @memberof GetAssessment200Response
     */
    'performance_window': AssessmentPerformanceWindow;
    /**
     * 
     * @type {boolean}
     * @memberof GetAssessment200Response
     */
    'required': boolean;
    /**
     * Patient ID
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'patient_id'?: string;
    /**
     * Creation timestamp
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'created'?: string;
    /**
     * Last update timestamp
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'updated'?: string;
    /**
     * Assessment provider name
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'provider'?: string;
    /**
     * Provider-specific metadata
     * @type {object}
     * @memberof GetAssessment200Response
     */
    'metadata'?: object;
    /**
     * Temporary URL for accessing the assessment
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'access_url'?: string | null;
    /**
     * Error message if URL generation failed
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'url_error'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAssessment200Response
     */
    'status'?: GetAssessment200ResponseStatusEnum;
}

export const GetAssessment200ResponseStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Expired: 'expired'
} as const;

export type GetAssessment200ResponseStatusEnum = typeof GetAssessment200ResponseStatusEnum[keyof typeof GetAssessment200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetDashboardEmbedUrl200Response
 */
export interface GetDashboardEmbedUrl200Response {
    /**
     * The URL to embed the dashboard
     * @type {string}
     * @memberof GetDashboardEmbedUrl200Response
     */
    'embedUrl'?: string;
}
/**
 * 
 * @export
 * @interface GetSurgeonMetrics200Response
 */
export interface GetSurgeonMetrics200Response {
    [key: string]: number | any;

    /**
     * Total count of TKA cases uploaded.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_total_count'?: number;
    /**
     * Total count of UKA cases uploaded.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'uka_total_count'?: number;
    /**
     * Average surgery time in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_avg_surgery_time'?: number;
    /**
     * Average surgery time for the first 20 cases performed in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_first_20_avg_surgery_time'?: number;
    /**
     * Average surgery time for the last 20 cases performed in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_last_20_avg_surgery_time'?: number;
    /**
     * Number of cases performed with final alignment varus.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_varus_case_count'?: number;
    /**
     * Number of cases performed with final alignment valgus.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_valgus_case_count'?: number;
    /**
     * Number of cases performed with final alignment neutral.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_neutral_case_count'?: number;
    /**
     * Number of cases performed final ROM in contracture.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_rom_flextion_contracture'?: number;
    /**
     * Average change in ROM in degrees for final alignment in contracture.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_rom_avg_flextion_delta_contracture'?: number;
    /**
     * Number of cases performed with hyperextension.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_rom_hyperextension'?: number;
    /**
     * Average change in ROM in degrees for final alignment in contracture.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'tka_rom_avg_flextion_delta_hyperextension'?: number;
    /**
     * Average surgery time in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'uka_avg_surgery_time'?: number;
    /**
     * Average surgery time for the first 20 cases performed in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'uka_first_20_avg_surgery_time'?: number;
    /**
     * Average surgery time for the last 20 cases performed in minutes.
     * @type {number}
     * @memberof GetSurgeonMetrics200Response
     */
    'uka_last_20_avg_surgery_time'?: number;
    /**
     * Record last uploaded timestamp (ISO 8601)
     * @type {string}
     * @memberof GetSurgeonMetrics200Response
     */
    'last_uploaded_date'?: string;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * Unique notification ID
     * @type {string}
     * @memberof Notification
     */
    'id': string;
    /**
     * URI for notification
     * @type {string}
     * @memberof Notification
     */
    'notification_uri': string;
    /**
     * Notification message
     * @type {string}
     * @memberof Notification
     */
    'text': string;
    /**
     * Icon type for the notification
     * @type {string}
     * @memberof Notification
     */
    'icon': NotificationIconEnum;
    /**
     * Notification type slug
     * @type {string}
     * @memberof Notification
     */
    'notification_slug': NotificationNotificationSlugEnum;
    /**
     * Time the notification was sent or last updated
     * @type {string}
     * @memberof Notification
     */
    'timestamp': string;
}

export const NotificationIconEnum = {
    Pain: 'Pain',
    Photo: 'Photo'
} as const;

export type NotificationIconEnum = typeof NotificationIconEnum[keyof typeof NotificationIconEnum];
export const NotificationNotificationSlugEnum = {
    PhotoUploaded: 'PHOTO_UPLOADED',
    AssessmentPain: 'ASSESSMENT_PAIN',
    PreOpPhotoUploaded: 'PRE_OP_PHOTO_UPLOADED'
} as const;

export type NotificationNotificationSlugEnum = typeof NotificationNotificationSlugEnum[keyof typeof NotificationNotificationSlugEnum];

/**
 * 
 * @export
 * @interface NotificationPreferences
 */
export interface NotificationPreferences {
    /**
     * List of user IDs to block notifications from
     * @type {Array<string>}
     * @memberof NotificationPreferences
     */
    'blacklisted_users'?: Array<string>;
    /**
     * 
     * @type {NotificationTypePreferences}
     * @memberof NotificationPreferences
     */
    'high_pain'?: NotificationTypePreferences;
    /**
     * 
     * @type {NotificationTypePreferences}
     * @memberof NotificationPreferences
     */
    'incision_photo'?: NotificationTypePreferences;
    /**
     * 
     * @type {NotificationTypePreferences}
     * @memberof NotificationPreferences
     */
    'pre_op_photo'?: NotificationTypePreferences;
}
/**
 * 
 * @export
 * @interface NotificationTypePreferences
 */
export interface NotificationTypePreferences {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTypePreferences
     */
    'email'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTypePreferences
     */
    'sms'?: boolean;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * Unique identifier for the organization
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * Name of the organization
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * Addresses with labels
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'addresses'?: { [key: string]: string; };
    /**
     * Locations of the organization
     * @type {Array<string>}
     * @memberof Organization
     */
    'locations': Array<string>;
    /**
     * Licenses assigned to the organization
     * @type {{ [key: string]: boolean; }}
     * @memberof Organization
     */
    'licenses'?: { [key: string]: boolean; };
    /**
     * Phone numbers with labels
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'phone_numbers'?: { [key: string]: string; };
    /**
     * Logos of the organization
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'logos'?: { [key: string]: string; };
    /**
     * Procedure of the organization
     * @type {Array<string>}
     * @memberof Organization
     */
    'procedures'?: Array<string>;
    /**
     * Websites with labels
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'websites'?: { [key: string]: string; };
    /**
     * Emails with labels
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'emails'?: { [key: string]: string; };
    /**
     * Geographical coordinates based off of addresses
     * @type {{ [key: string]: OrganizationCoordinatesValue; }}
     * @memberof Organization
     */
    'coordinates'?: { [key: string]: OrganizationCoordinatesValue; };
    /**
     * Timezone of the organization
     * @type {string}
     * @memberof Organization
     */
    'timezone'?: string;
}
/**
 * 
 * @export
 * @interface OrganizationCoordinatesValue
 */
export interface OrganizationCoordinatesValue {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCoordinatesValue
     */
    'latitude': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCoordinatesValue
     */
    'longitude': string;
}
/**
 * 
 * @export
 * @interface Patient
 */
export interface Patient {
    /**
     * Unique patient identifier
     * @type {string}
     * @memberof Patient
     */
    'patient_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof Patient
     */
    'last_name': string;
    /**
     * Date of birth (ISO 8601 date)
     * @type {string}
     * @memberof Patient
     */
    'dob': string;
    /**
     * Mobile phone number
     * @type {string}
     * @memberof Patient
     */
    'mobile'?: string;
    /**
     * Gender of the patient
     * @type {string}
     * @memberof Patient
     */
    'gender'?: PatientGenderEnum;
    /**
     * Patient email
     * @type {string}
     * @memberof Patient
     */
    'email': string;
    /**
     * Medical record number
     * @type {string}
     * @memberof Patient
     */
    'mrn': string;
    /**
     * 
     * @type {TermsOfAcceptance}
     * @memberof Patient
     */
    'terms_of_acceptance'?: TermsOfAcceptance;
    /**
     * Enrollment ID associated with the patient
     * @type {string}
     * @memberof Patient
     */
    'enrollment_id'?: string;
    /**
     * Timestamp the patient record was created. Null for records created before this field existed.
     * @type {string}
     * @memberof Patient
     */
    'created_at'?: string;
    /**
     * Timestamp of the most recent update to this patient record.
     * @type {string}
     * @memberof Patient
     */
    'updated_at'?: string;
    /**
     * Cognito UserStatus (e.g. CONFIRMED, FORCE_CHANGE_PASSWORD, RESET_REQUIRED). No enum constraint -- passed through as a plain string so an unexpected Cognito value doesn\'t fail response validation. Null if the Cognito lookup fails.
     * @type {string}
     * @memberof Patient
     */
    'status'?: string;
    /**
     * Cognito Enabled flag -- whether the account can sign in at all. Null if the Cognito lookup fails.
     * @type {boolean}
     * @memberof Patient
     */
    'enabled'?: boolean;
    /**
     * Timestamp of the most recent password set -- initial registration or any later admin/self reset.
     * @type {string}
     * @memberof Patient
     */
    'password_last_updated_at'?: string;
    /**
     * True if more than 2 days have elapsed since password_last_updated_at -- mirrors the temporary password validity window.
     * @type {boolean}
     * @memberof Patient
     */
    'expired'?: boolean;
}

export const PatientGenderEnum = {
    M: 'M',
    F: 'F',
    Other: 'Other'
} as const;

export type PatientGenderEnum = typeof PatientGenderEnum[keyof typeof PatientGenderEnum];

/**
 * 
 * @export
 * @interface PatientCarePlanUploadRequest
 */
export interface PatientCarePlanUploadRequest {
    /**
     * Type of template (currently only \"bespoke\" is created)
     * @type {string}
     * @memberof PatientCarePlanUploadRequest
     */
    'template_type': PatientCarePlanUploadRequestTemplateTypeEnum;
    /**
     * Name of the generic/bespoke template
     * @type {string}
     * @memberof PatientCarePlanUploadRequest
     */
    'name'?: string;
}

export const PatientCarePlanUploadRequestTemplateTypeEnum = {
    Generic: 'generic',
    Bespoke: 'bespoke'
} as const;

export type PatientCarePlanUploadRequestTemplateTypeEnum = typeof PatientCarePlanUploadRequestTemplateTypeEnum[keyof typeof PatientCarePlanUploadRequestTemplateTypeEnum];

/**
 * 
 * @export
 * @interface PatientCarePlanUploadResponse
 */
export interface PatientCarePlanUploadResponse {
    /**
     * Generic template ID used to create the bespoke care plan
     * @type {string}
     * @memberof PatientCarePlanUploadResponse
     */
    'template_id': string;
    /**
     * Pre-signed S3 URL for uploading the care plan JSON
     * @type {string}
     * @memberof PatientCarePlanUploadResponse
     */
    'pre_signed_url': string;
    /**
     * Additional headers to be used in the upload photo request
     * @type {{ [key: string]: string; }}
     * @memberof PatientCarePlanUploadResponse
     */
    'additional_headers'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PatientEnrollment
 */
export interface PatientEnrollment {
    /**
     * 
     * @type {string}
     * @memberof PatientEnrollment
     */
    'org_id': string;
    /**
     * 
     * @type {Patient}
     * @memberof PatientEnrollment
     */
    'patient': Patient;
    /**
     * 
     * @type {Enrollment}
     * @memberof PatientEnrollment
     */
    'enrollment': Enrollment;
}
/**
 * 
 * @export
 * @interface PatientPhoto
 */
export interface PatientPhoto {
    /**
     * Unique Photo ID
     * @type {string}
     * @memberof PatientPhoto
     */
    'id': string;
    /**
     * Organization ID
     * @type {string}
     * @memberof PatientPhoto
     */
    'organization_id'?: string;
    /**
     * Enrollment ID
     * @type {string}
     * @memberof PatientPhoto
     */
    'enrollment_id'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof PatientPhoto
     */
    'pre_signed_url': string;
    /**
     * Photo Upload Date
     * @type {string}
     * @memberof PatientPhoto
     */
    'uploaded_date': string;
    /**
     * jpg, png, pdf
     * @type {string}
     * @memberof PatientPhoto
     */
    'file_type': string;
    /**
     * 
     * @type {string}
     * @memberof PatientPhoto
     */
    'photo_type': PatientPhotoPhotoTypeEnum;
    /**
     * Provider Response
     * @type {string}
     * @memberof PatientPhoto
     */
    'provider_response'?: string;
    /**
     * Date Time Provider Responded
     * @type {string}
     * @memberof PatientPhoto
     */
    'provider_response_date'?: string;
    /**
     * Provider Response
     * @type {string}
     * @memberof PatientPhoto
     */
    'patient_response'?: string;
    /**
     * Date Time Provider Responded
     * @type {string}
     * @memberof PatientPhoto
     */
    'patient_response_date'?: string;
}

export const PatientPhotoPhotoTypeEnum = {
    PreOpSurgicalSite: 'pre-op-surgical-site',
    Incision: 'incision'
} as const;

export type PatientPhotoPhotoTypeEnum = typeof PatientPhotoPhotoTypeEnum[keyof typeof PatientPhotoPhotoTypeEnum];

/**
 * 
 * @export
 * @interface PatientPhotoUploadRequest
 */
export interface PatientPhotoUploadRequest {
    /**
     * Type of file being uploaded
     * @type {string}
     * @memberof PatientPhotoUploadRequest
     */
    'photo_type'?: PatientPhotoUploadRequestPhotoTypeEnum;
    /**
     * File type/extension of the file being uploaded
     * @type {string}
     * @memberof PatientPhotoUploadRequest
     */
    'file_type'?: PatientPhotoUploadRequestFileTypeEnum;
    /**
     * Patient ID
     * @type {string}
     * @memberof PatientPhotoUploadRequest
     */
    'patient_id': string;
    /**
     * Patient Response to photo upload
     * @type {string}
     * @memberof PatientPhotoUploadRequest
     */
    'patient_response'?: string;
    /**
     * Icon type for the notification
     * @type {string}
     * @memberof PatientPhotoUploadRequest
     */
    'icon'?: string;
}

export const PatientPhotoUploadRequestPhotoTypeEnum = {
    Incision: 'incision',
    PreOpSurgicalSite: 'pre-op-surgical-site'
} as const;

export type PatientPhotoUploadRequestPhotoTypeEnum = typeof PatientPhotoUploadRequestPhotoTypeEnum[keyof typeof PatientPhotoUploadRequestPhotoTypeEnum];
export const PatientPhotoUploadRequestFileTypeEnum = {
    Jpg: 'jpg',
    Png: 'png',
    Pdf: 'pdf',
    Heic: 'heic'
} as const;

export type PatientPhotoUploadRequestFileTypeEnum = typeof PatientPhotoUploadRequestFileTypeEnum[keyof typeof PatientPhotoUploadRequestFileTypeEnum];

/**
 * 
 * @export
 * @interface PatientPhotoUploadResponse
 */
export interface PatientPhotoUploadResponse {
    /**
     * Unique Photo ID
     * @type {string}
     * @memberof PatientPhotoUploadResponse
     */
    'id'?: string;
    /**
     * Pre-signed S3 URL for uploading the file
     * @type {string}
     * @memberof PatientPhotoUploadResponse
     */
    'pre_signed_url'?: string;
    /**
     * Additional headers to be used in the upload photo request
     * @type {{ [key: string]: string; }}
     * @memberof PatientPhotoUploadResponse
     */
    'additional_headers'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PatientsPromsMetric
 */
export interface PatientsPromsMetric {
    /**
     * Name of the PROMS survey
     * @type {string}
     * @memberof PatientsPromsMetric
     */
    'survey_name': PatientsPromsMetricSurveyNameEnum;
    /**
     * Average score for the survey (latest measurement)
     * @type {number}
     * @memberof PatientsPromsMetric
     */
    'avg_score': number;
}

export const PatientsPromsMetricSurveyNameEnum = {
    Koosjr: 'KOOSJR',
    Hoosjr: 'HOOSJR',
    Ases: 'ASES',
    Rom: 'ROM',
    Vas: 'VAS'
} as const;

export type PatientsPromsMetricSurveyNameEnum = typeof PatientsPromsMetricSurveyNameEnum[keyof typeof PatientsPromsMetricSurveyNameEnum];

/**
 * 
 * @export
 * @interface PendingPatientEnrollment
 */
export interface PendingPatientEnrollment {
    /**
     * Pending Patient Enrollment Unique ID
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'last_name': string;
    /**
     * Medical record number
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'mrn': string;
    /**
     * Date of birth (ISO 8601 date)
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'dob': string;
    /**
     * Gender of the patient
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'gender': PendingPatientEnrollmentGenderEnum;
    /**
     * Patient email
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'email': string;
    /**
     * Mobile phone number
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'mobile'?: string;
    /**
     * Care Plan ID
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'care_plan'?: string;
    /**
     * Procedure Name
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'procedure'?: string;
    /**
     * Surgeon NPI
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'surgeon'?: string;
    /**
     * Location Name
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'location'?: string;
    /**
     * Surgery Date (ISO 8601 date)
     * @type {string}
     * @memberof PendingPatientEnrollment
     */
    'surgery_date'?: string;
}

export const PendingPatientEnrollmentGenderEnum = {
    M: 'M',
    F: 'F',
    Other: 'Other'
} as const;

export type PendingPatientEnrollmentGenderEnum = typeof PendingPatientEnrollmentGenderEnum[keyof typeof PendingPatientEnrollmentGenderEnum];

/**
 * 
 * @export
 * @interface PostOpMetricsResponse
 */
export interface PostOpMetricsResponse {
    /**
     * AWS QuickSight embed URL for patient post-op metrics
     * @type {string}
     * @memberof PostOpMetricsResponse
     */
    'embed_url': string;
}
/**
 * 
 * @export
 * @interface PredefinedAction
 */
export interface PredefinedAction {
    /**
     * Unique identifier for the predefined action
     * @type {string}
     * @memberof PredefinedAction
     */
    'id'?: string;
    /**
     * Organization ID this action belongs to
     * @type {string}
     * @memberof PredefinedAction
     */
    'org_id'?: string;
    /**
     * Short title for the action
     * @type {string}
     * @memberof PredefinedAction
     */
    'title': string;
    /**
     * Detailed description of the action
     * @type {string}
     * @memberof PredefinedAction
     */
    'description': string;
    /**
     * Whether this action is required
     * @type {boolean}
     * @memberof PredefinedAction
     */
    'required': boolean;
    /**
     * Array of reminders for this action (maximum 2)
     * @type {Array<Reminder>}
     * @memberof PredefinedAction
     */
    'reminders'?: Array<Reminder>;
    /**
     * Array of linked assets for this action
     * @type {Array<Asset>}
     * @memberof PredefinedAction
     */
    'assets'?: Array<Asset>;
    /**
     * Timestamp when the action was created
     * @type {string}
     * @memberof PredefinedAction
     */
    'created_at'?: string;
    /**
     * Timestamp when the action was last updated
     * @type {string}
     * @memberof PredefinedAction
     */
    'updated_at'?: string;
    /**
     * Number Days Before or After Surgery
     * @type {string}
     * @memberof PredefinedAction
     */
    'delta_days_from_surgery': string;
    /**
     * Track Item origination
     * @type {string}
     * @memberof PredefinedAction
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface Reminder
 */
export interface Reminder {
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'execution_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Reminder
     */
    'always_send': boolean;
    /**
     * 
     * @type {number}
     * @memberof Reminder
     */
    'days_before_due_to_remind': number;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'reminder_type'?: ReminderReminderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Reminder
     */
    'reminder_repeat_interval_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof Reminder
     */
    'destination'?: string;
}

export const ReminderReminderTypeEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type ReminderReminderTypeEnum = typeof ReminderReminderTypeEnum[keyof typeof ReminderReminderTypeEnum];

/**
 * 
 * @export
 * @interface Surgeon
 */
export interface Surgeon {
    /**
     * User ID
     * @type {string}
     * @memberof Surgeon
     */
    'surgeon_id'?: string;
    /**
     * Surgeon NPI
     * @type {string}
     * @memberof Surgeon
     */
    'npi'?: string;
    /**
     * Surgeon Fullname
     * @type {string}
     * @memberof Surgeon
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface Surgery
 */
export interface Surgery {
    /**
     * Patient unique ID (hash)
     * @type {string}
     * @memberof Surgery
     */
    'patient_id': string;
    /**
     * Case unique ID (hash)
     * @type {string}
     * @memberof Surgery
     */
    'case_id'?: string;
    /**
     * User ID
     * @type {string}
     * @memberof Surgery
     */
    'user_id'?: string;
    /**
     * Surgeon Identifier
     * @type {string}
     * @memberof Surgery
     */
    'surgeon_npi'?: string;
    /**
     * CSV file key reference
     * @type {string}
     * @memberof Surgery
     */
    'csv_key'?: string | null;
    /**
     * List of PDF file keys
     * @type {Array<string>}
     * @memberof Surgery
     */
    'pdf_keys'?: Array<string> | null;
    /**
     * List of JPEG file keys
     * @type {Array<string>}
     * @memberof Surgery
     */
    'jpeg_keys'?: Array<string> | null;
    /**
     * Organization ID
     * @type {string}
     * @memberof Surgery
     */
    'org_id': string;
    /**
     * Patient\'s first name
     * @type {string}
     * @memberof Surgery
     */
    'first_name'?: string | null;
    /**
     * Patient\'s middle name (optional)
     * @type {string}
     * @memberof Surgery
     */
    'middle_name'?: string | null;
    /**
     * Patient\'s last name
     * @type {string}
     * @memberof Surgery
     */
    'last_name'?: string | null;
    /**
     * Date of birth (ISO 8601 date)
     * @type {string}
     * @memberof Surgery
     */
    'dob'?: string | null;
    /**
     * Patient gender
     * @type {string}
     * @memberof Surgery
     */
    'gender': SurgeryGenderEnum;
    /**
     * Active or archived flag
     * @type {boolean}
     * @memberof Surgery
     */
    'active': boolean;
    /**
     * Record creation timestamp (ISO 8601)
     * @type {string}
     * @memberof Surgery
     */
    'created_at': string;
    /**
     * 
     * @type {VICaseData}
     * @memberof Surgery
     */
    'vi_case_data'?: VICaseData;
}

export const SurgeryGenderEnum = {
    Female: 'female',
    Male: 'male',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type SurgeryGenderEnum = typeof SurgeryGenderEnum[keyof typeof SurgeryGenderEnum];

/**
 * 
 * @export
 * @interface TermsOfAcceptance
 */
export interface TermsOfAcceptance {
    /**
     * Whether patient accepted the terms
     * @type {boolean}
     * @memberof TermsOfAcceptance
     */
    'accepted': boolean;
    /**
     * ISO date-time when the terms were accepted
     * @type {string}
     * @memberof TermsOfAcceptance
     */
    'accepted_date'?: string;
    /**
     * Version of the collection statement
     * @type {string}
     * @memberof TermsOfAcceptance
     */
    'collection_statement_version': string;
    /**
     * Version of the privacy policy
     * @type {string}
     * @memberof TermsOfAcceptance
     */
    'privacy_policy_version': string;
    /**
     * Version of the terms of use
     * @type {string}
     * @memberof TermsOfAcceptance
     */
    'terms_of_use_version': string;
}
/**
 * 
 * @export
 * @interface UpdatePatientEnrollmentRequest
 */
export interface UpdatePatientEnrollmentRequest {
    /**
     * Surgery date (YYYY-MM-DD)
     * @type {string}
     * @memberof UpdatePatientEnrollmentRequest
     */
    'surgery_date': string;
    /**
     * 
     * @type {Array<Action>}
     * @memberof UpdatePatientEnrollmentRequest
     */
    'actions': Array<Action>;
    /**
     * 
     * @type {Array<Broadcast>}
     * @memberof UpdatePatientEnrollmentRequest
     */
    'broadcasts': Array<Broadcast>;
    /**
     * 
     * @type {Array<Event>}
     * @memberof UpdatePatientEnrollmentRequest
     */
    'events': Array<Event>;
}
/**
 * 
 * @export
 * @interface UploadRequest
 */
export interface UploadRequest {
    /**
     * 
     * @type {UploadRequestUpload}
     * @memberof UploadRequest
     */
    'upload': UploadRequestUpload;
}
/**
 * 
 * @export
 * @interface UploadRequestUpload
 */
export interface UploadRequestUpload {
    /**
     * Organization unique identifier
     * @type {string}
     * @memberof UploadRequestUpload
     */
    'org_id': string;
    /**
     * Name of the zip file to be uploaded
     * @type {string}
     * @memberof UploadRequestUpload
     */
    'zip_filename': string;
    /**
     * location name
     * @type {string}
     * @memberof UploadRequestUpload
     */
    'location_name': string;
    /**
     * Password for encrypted zip file
     * @type {string}
     * @memberof UploadRequestUpload
     */
    'zip_enc_password': string;
    /**
     * Surgeon NPI
     * @type {string}
     * @memberof UploadRequestUpload
     */
    'surgeon_npi': string;
}
/**
 * 
 * @export
 * @interface UploadResponse
 */
export interface UploadResponse {
    /**
     * 
     * @type {UploadResponseUpload}
     * @memberof UploadResponse
     */
    'upload'?: UploadResponseUpload;
    /**
     * The pre-signed URL to upload the ZIP file
     * @type {string}
     * @memberof UploadResponse
     */
    'pre_signed_url'?: string;
    /**
     * Additional headers to be used in the upload request
     * @type {{ [key: string]: string; }}
     * @memberof UploadResponse
     */
    'additional_headers'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UploadResponseUpload
 */
export interface UploadResponseUpload {
    /**
     * 
     * @type {string}
     * @memberof UploadResponseUpload
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponseUpload
     */
    'status': UploadResponseUploadStatusEnum;
    /**
     * Any error details from upload
     * @type {string}
     * @memberof UploadResponseUpload
     */
    'status_details'?: string;
}

export const UploadResponseUploadStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type UploadResponseUploadStatusEnum = typeof UploadResponseUploadStatusEnum[keyof typeof UploadResponseUploadStatusEnum];

/**
 * 
 * @export
 * @interface UserPreferences
 */
export interface UserPreferences {
    /**
     * 
     * @type {UserPreferencesPreferences}
     * @memberof UserPreferences
     */
    'preferences'?: UserPreferencesPreferences;
}
/**
 * 
 * @export
 * @interface UserPreferencesPreferences
 */
export interface UserPreferencesPreferences {
    /**
     * 
     * @type {NotificationPreferences}
     * @memberof UserPreferencesPreferences
     */
    'notifications'?: NotificationPreferences;
}
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfile
     */
    'phone_number_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'gender': UserProfileGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'org_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'role': UserProfileRoleEnum;
    /**
     * Licenses assigned to the user
     * @type {{ [key: string]: boolean; }}
     * @memberof UserProfile
     */
    'licenses'?: { [key: string]: boolean; };
    /**
     * Cognito UserStatus (e.g. CONFIRMED, FORCE_CHANGE_PASSWORD, RESET_REQUIRED). No enum constraint -- passed through as a plain string so an unexpected Cognito value doesn\'t fail response validation. Null if the Cognito lookup fails.
     * @type {string}
     * @memberof UserProfile
     */
    'status'?: string;
    /**
     * Cognito Enabled flag -- whether the account can sign in at all. Null if the Cognito lookup fails.
     * @type {boolean}
     * @memberof UserProfile
     */
    'enabled'?: boolean;
    /**
     * Timestamp the user record was created. Null for records created before this field existed.
     * @type {string}
     * @memberof UserProfile
     */
    'created_at'?: string;
    /**
     * Timestamp of the most recent update to this user record.
     * @type {string}
     * @memberof UserProfile
     */
    'updated_at'?: string;
    /**
     * Timestamp of the most recent password set -- initial registration or any later admin/self reset.
     * @type {string}
     * @memberof UserProfile
     */
    'password_last_updated_at'?: string;
    /**
     * True if more than 2 days have elapsed since password_last_updated_at -- mirrors the temporary password validity window.
     * @type {boolean}
     * @memberof UserProfile
     */
    'expired'?: boolean;
}

export const UserProfileGenderEnum = {
    M: 'M',
    F: 'F',
    Other: 'Other'
} as const;

export type UserProfileGenderEnum = typeof UserProfileGenderEnum[keyof typeof UserProfileGenderEnum];
export const UserProfileRoleEnum = {
    Provider: 'provider',
    Admin: 'admin',
    Patient: 'patient',
    Scheduler: 'scheduler'
} as const;

export type UserProfileRoleEnum = typeof UserProfileRoleEnum[keyof typeof UserProfileRoleEnum];

/**
 * 
 * @export
 * @interface VICaseData
 */
export interface VICaseData {
    [key: string]: string | any;

    /**
     * Side of treatment
     * @type {string}
     * @memberof VICaseData
     */
    'treatment_side'?: VICaseDataTreatmentSideEnum | null;
    /**
     * Name of the procedure
     * @type {string}
     * @memberof VICaseData
     */
    'procedure'?: string;
    /**
     * Computed procedure type (e.g., TKA, UKA)
     * @type {string}
     * @memberof VICaseData
     */
    'procedure_type'?: VICaseDataProcedureTypeEnum;
    /**
     * Surgeon performing the procedure
     * @type {string}
     * @memberof VICaseData
     */
    'surgeon'?: string;
    /**
     * Surgery date (ISO 8601 date)
     * @type {string}
     * @memberof VICaseData
     */
    'surgery_date'?: string;
    /**
     * Computed surgery phase
     * @type {string}
     * @memberof VICaseData
     */
    'surgery_phase'?: VICaseDataSurgeryPhaseEnum;
    /**
     * Location of surgery
     * @type {string}
     * @memberof VICaseData
     */
    'location'?: string;
    /**
     * Which program patient is in
     * @type {string}
     * @memberof VICaseData
     */
    'patient_program'?: VICaseDataPatientProgramEnum;
    /**
     * Insert size for tibia
     * @type {string}
     * @memberof VICaseData
     */
    'tibia_insert_size'?: string;
    /**
     * Implant size for femur
     * @type {string}
     * @memberof VICaseData
     */
    'femur_implant_size'?: string;
    /**
     * Implant type
     * @type {string}
     * @memberof VICaseData
     */
    'implant_type'?: string;
}

export const VICaseDataTreatmentSideEnum = {
    Left: 'left',
    Right: 'right',
    Bilateral: 'bilateral',
    Unknown: 'unknown'
} as const;

export type VICaseDataTreatmentSideEnum = typeof VICaseDataTreatmentSideEnum[keyof typeof VICaseDataTreatmentSideEnum];
export const VICaseDataProcedureTypeEnum = {
    Tka: 'TKA',
    Uka: 'UKA',
    Other: 'other'
} as const;

export type VICaseDataProcedureTypeEnum = typeof VICaseDataProcedureTypeEnum[keyof typeof VICaseDataProcedureTypeEnum];
export const VICaseDataSurgeryPhaseEnum = {
    PreOp: 'pre-op',
    PostOp: 'post-op',
    None: 'none'
} as const;

export type VICaseDataSurgeryPhaseEnum = typeof VICaseDataSurgeryPhaseEnum[keyof typeof VICaseDataSurgeryPhaseEnum];
export const VICaseDataPatientProgramEnum = {
    Vi: 'VI',
    Vpp: 'VPP',
    Both: 'BOTH'
} as const;

export type VICaseDataPatientProgramEnum = typeof VICaseDataPatientProgramEnum[keyof typeof VICaseDataPatientProgramEnum];


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows administrators to reset a user\'s password. Requires admin role and organization membership validation.
         * @summary Admin password reset for user
         * @param {string} userId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPasswordReset: async (userId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminPasswordReset', 'userId', userId)
            // verify required parameter 'adminPasswordResetRequest' is not null or undefined
            assertParamExists('adminPasswordReset', 'adminPasswordResetRequest', adminPasswordResetRequest)
            const localVarPath = `/admin/users/{user_id}/password-reset`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new patient enrollment w/ care plan details for an organization.
         * @summary Create care plan specific to patient enrollment
         * @param {string} orgId Organization ID
         * @param {CreatePatientEnrollmentRequest} createPatientEnrollmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientEnrollment: async (orgId: string, createPatientEnrollmentRequest: CreatePatientEnrollmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createPatientEnrollment', 'orgId', orgId)
            // verify required parameter 'createPatientEnrollmentRequest' is not null or undefined
            assertParamExists('createPatientEnrollment', 'createPatientEnrollmentRequest', createPatientEnrollmentRequest)
            const localVarPath = `/organizations/{org_id}/enrollments`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatientEnrollmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create pending patient enrollment saving patient details & partial enrollment details.
         * @summary Create a pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPendingPatientEnrollment: async (orgId: string, pendingPatientEnrollment: PendingPatientEnrollment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createPendingPatientEnrollment', 'orgId', orgId)
            // verify required parameter 'pendingPatientEnrollment' is not null or undefined
            assertParamExists('createPendingPatientEnrollment', 'pendingPatientEnrollment', pendingPatientEnrollment)
            const localVarPath = `/organizations/{org_id}/pending_patient_enrollments`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pendingPatientEnrollment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new predefined action item for an organization.
         * @summary Create a predefined action item
         * @param {string} orgId Organization ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedAction: async (orgId: string, predefinedAction: PredefinedAction, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createPredefinedAction', 'orgId', orgId)
            // verify required parameter 'predefinedAction' is not null or undefined
            assertParamExists('createPredefinedAction', 'predefinedAction', predefinedAction)
            const localVarPath = `/organizations/{org_id}/predefined-actions`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predefinedAction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create upload request
         * @param {string} orgId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadRequest: async (orgId: string, uploadRequest: UploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createUploadRequest', 'orgId', orgId)
            // verify required parameter 'uploadRequest' is not null or undefined
            assertParamExists('createUploadRequest', 'uploadRequest', uploadRequest)
            const localVarPath = `/organizations/{org_id}/upload`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a notification for an organization by its ID.
         * @summary Delete organization notification
         * @param {string} orgId Organization ID
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgNotification: async (orgId: string, notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrgNotification', 'orgId', orgId)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteOrgNotification', 'notificationId', notificationId)
            const localVarPath = `/organizations/{org_id}/notifications/{notification_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel or delete an existing patient enrollment for the given organization.
         * @summary Cancel a current enrollment
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientEnrollment: async (orgId: string, enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deletePatientEnrollment', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('deletePatientEnrollment', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete items from an enrollment for action, event, broadcast
         * @summary Delete patient enrollment items Action, Event, Broadcast
         * @param {string} orgId 
         * @param {string} enrollmentId 
         * @param {BulkDeleteItemsRequest} bulkDeleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientEnrollmentItems: async (orgId: string, enrollmentId: string, bulkDeleteItemsRequest: BulkDeleteItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deletePatientEnrollmentItems', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('deletePatientEnrollmentItems', 'enrollmentId', enrollmentId)
            // verify required parameter 'bulkDeleteItemsRequest' is not null or undefined
            assertParamExists('deletePatientEnrollmentItems', 'bulkDeleteItemsRequest', bulkDeleteItemsRequest)
            const localVarPath = `/organizations/{org_id}/enrollment-items/{enrollment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes/Removes a pending patient enrollment by it ID.
         * @summary Delete/Remove pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePendingPatientEnrollment: async (orgId: string, pendingPatientEnrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deletePendingPatientEnrollment', 'orgId', orgId)
            // verify required parameter 'pendingPatientEnrollmentId' is not null or undefined
            assertParamExists('deletePendingPatientEnrollment', 'pendingPatientEnrollmentId', pendingPatientEnrollmentId)
            const localVarPath = `/organizations/{org_id}/pending_patient_enrollments/{pending_patient_enrollment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"pending_patient_enrollment_id"}}`, encodeURIComponent(String(pendingPatientEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a predefined action item from an organization.
         * @summary Delete a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePredefinedAction: async (orgId: string, actionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deletePredefinedAction', 'orgId', orgId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deletePredefinedAction', 'actionId', actionId)
            const localVarPath = `/organizations/{org_id}/predefined-actions/{action_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Download files as CSV and send email notification
         * @param {string} orgId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFiles: async (orgId: string, downloadRequest: DownloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('downloadFiles', 'orgId', orgId)
            // verify required parameter 'downloadRequest' is not null or undefined
            assertParamExists('downloadFiles', 'downloadRequest', downloadRequest)
            const localVarPath = `/organizations/{org_id}/files/download-csv`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a Signed URL to download the prepared export CSV file for the specified organization.
         * @summary Get a link to the generated CSV file
         * @param {string} orgId 
         * @param {string} downloadId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesLink: async (orgId: string, downloadId: string, downloadRequest: DownloadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('downloadFilesLink', 'orgId', orgId)
            // verify required parameter 'downloadId' is not null or undefined
            assertParamExists('downloadFilesLink', 'downloadId', downloadId)
            // verify required parameter 'downloadRequest' is not null or undefined
            assertParamExists('downloadFilesLink', 'downloadRequest', downloadRequest)
            const localVarPath = `/organizations/{org_id}/files/download-csv/{download_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"download_id"}}`, encodeURIComponent(String(downloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves assessment details and generates a temporary access URL for LainaHealth assessment completion
         * @summary Get assessment details with access URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessment: async (orgId: string, enrollmentId: string, assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getAssessment', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getAssessment', 'enrollmentId', enrollmentId)
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/assessments/{assessment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Get an Embed URL for an organization\'s dashboard
         * @param {string} orgId 
         * @param {GetDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl: async (orgId: string, slug: GetDashboardEmbedUrlSlugEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'orgId', orgId)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'slug', slug)
            const localVarPath = `/organizations/{org_id}/dashboards/{slug}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a Quicksight Embed URL for an enrollment scope
         * @summary Get an Embed URL for an Enrollment\'s dashboard
         * @param {string} enrollmentId 
         * @param {GetEnrollmentDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentDashboardEmbedUrl: async (enrollmentId: string, slug: GetEnrollmentDashboardEmbedUrlSlugEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getEnrollmentDashboardEmbedUrl', 'enrollmentId', enrollmentId)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getEnrollmentDashboardEmbedUrl', 'slug', slug)
            const localVarPath = `/enrollments/{enrollment_id}/dashboards/{slug}`
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single photo for a patient enrollment by photo ID.
         * @summary Get patient enrollment photo by ID
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentPhoto: async (orgId: string, id: string, enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getEnrollmentPhoto', 'orgId', orgId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEnrollmentPhoto', 'id', id)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getEnrollmentPhoto', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/photos/{id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Profile
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrg', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves notifications for an organization.
         * @summary List organization notifications
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgNotifications: async (orgId: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrgNotifications', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/notifications`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single patient record by patient ID
         * @summary Get patient by patient ID
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatient', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a patient enrollment by enrollment_id
         * @summary Get patient enrollment by enrollment_id
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollment: async (enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getPatientEnrollment', 'enrollmentId', enrollmentId)
            const localVarPath = `/enrollments/{enrollment_id}`
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a patient enrollment\'s action item by action_id from an organization.
         * @summary Get an enrollment action item by action_id
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollmentAction: async (orgId: string, enrollmentId: string, actionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPatientEnrollmentAction', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getPatientEnrollmentAction', 'enrollmentId', enrollmentId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('getPatientEnrollmentAction', 'actionId', actionId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/actions/{action_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List a patient enrollment\'s action items from an organization, filter by status or date.
         * @summary List of an enrollment\'s action items
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {GetPatientEnrollmentActionsStatusEnum} [status] Filter actions by status
         * @param {string} [date] Filter actions by date (YYYY-MM-DD)
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollmentActions: async (orgId: string, enrollmentId: string, status?: GetPatientEnrollmentActionsStatusEnum, date?: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPatientEnrollmentActions', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getPatientEnrollmentActions', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/actions`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of patient enrollments from an org. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary Get list of patient enrollments
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter enrollments by one or more surgeon IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollments: async (orgId: string, cursor?: string, q?: string, surgeonNpi?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPatientEnrollments', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/enrollments`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (surgeonNpi) {
                localVarQueryParameter['surgeon_npi'] = surgeonNpi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an AWS QuickSight embed URL for viewing a patient\'s post-operative metrics.
         * @summary Get patient post-op metrics embed URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPostopMetrics: async (orgId: string, enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPatientPostopMetrics', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getPatientPostopMetrics', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/metrics`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest Patient-Reported Outcome Measures (PROMS) survey data for a specific patient enrollment, including KOOSJR, HOOSJR, ASES, ROM, and VAS scores.
         * @summary Get patient PROMS metrics
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPromsMetrics: async (orgId: string, enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPatientPromsMetrics', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('getPatientPromsMetrics', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/proms`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of patients for an organization.
         * @summary List patients in an organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatients: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a pending patient enrollment for an organization.
         * @summary Get a pending patient enrollment by pending_patient_enrollment_id
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPatientEnrollment: async (orgId: string, pendingPatientEnrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPendingPatientEnrollment', 'orgId', orgId)
            // verify required parameter 'pendingPatientEnrollmentId' is not null or undefined
            assertParamExists('getPendingPatientEnrollment', 'pendingPatientEnrollmentId', pendingPatientEnrollmentId)
            const localVarPath = `/organizations/{org_id}/pending_patient_enrollments/{pending_patient_enrollment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"pending_patient_enrollment_id"}}`, encodeURIComponent(String(pendingPatientEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves pending patient enrollments for an organization. These are the patients w/o surgery_date or missing other enrollment details. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary List organization pending patient enrollments
         * @param {string} orgId Organization ID
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter by one or more surgeon IDs
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPatientEnrollments: async (orgId: string, q?: string, surgeonNpi?: Array<string>, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPendingPatientEnrollments', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/pending_patient_enrollments`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (surgeonNpi) {
                localVarQueryParameter['surgeon_npi'] = surgeonNpi;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific predefined action item by its ID.
         * @summary Get a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedAction: async (orgId: string, actionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getPredefinedAction', 'orgId', orgId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('getPredefinedAction', 'actionId', actionId)
            const localVarPath = `/organizations/{org_id}/predefined-actions/{action_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of procedures for an organization.
         * @summary List procedures in an organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcedures: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getProcedures', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/procedures`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List metrics for uploaded case data for a surgeon in an organization
         * @summary List surgeon case upload metrics
         * @param {string} orgId 
         * @param {string} surgeonNpi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeonMetrics: async (orgId: string, surgeonNpi: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getSurgeonMetrics', 'orgId', orgId)
            // verify required parameter 'surgeonNpi' is not null or undefined
            assertParamExists('getSurgeonMetrics', 'surgeonNpi', surgeonNpi)
            const localVarPath = `/organizations/{org_id}/surgeons/{surgeon_npi}/metrics`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"surgeon_npi"}}`, encodeURIComponent(String(surgeonNpi)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of surgeons for an organization.
         * @summary List surgeons in an organization
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeons: async (orgId: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getSurgeons', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/surgeons`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Combined list, filter, and search endpoint for surgeries within an organization. Supports filters like name, date of birth, location, procedure type, surgery phase, and active status. Pagination is supported using `cursor`.
         * @summary List surgeries in an organization
         * @param {string} orgId 
         * @param {string} [q] Search query to filter results by
         * @param {string} [location] 
         * @param {GetSurgeriesProcedureTypeEnum} [procedureType] 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeries: async (orgId: string, q?: string, location?: string, procedureType?: GetSurgeriesProcedureTypeEnum, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getSurgeries', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/surgeries`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (procedureType !== undefined) {
                localVarQueryParameter['procedure_type'] = procedureType;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single surgery record by case ID within a specific organization.
         * @summary Get surgery by case ID
         * @param {string} orgId 
         * @param {string} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgery: async (orgId: string, caseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getSurgery', 'orgId', orgId)
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getSurgery', 'caseId', caseId)
            const localVarPath = `/organizations/{org_id}/surgeries/{case_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get generic care plan template for the given organization.
         * @summary Get generic care plan template of an organization
         * @param {string} orgId Organization ID
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (orgId: string, templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getTemplate', 'orgId', orgId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplate', 'templateId', templateId)
            const localVarPath = `/organizations/{org_id}/templates/{template_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a pre-signed S3 URL for creating a bespoke patient care plan based on a generic template.
         * @summary Get pre-signed URL to upload patient care plan from base template
         * @param {string} orgId Organization ID
         * @param {PatientCarePlanUploadRequest} patientCarePlanUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUploadRequest: async (orgId: string, patientCarePlanUploadRequest: PatientCarePlanUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getTemplateUploadRequest', 'orgId', orgId)
            // verify required parameter 'patientCarePlanUploadRequest' is not null or undefined
            assertParamExists('getTemplateUploadRequest', 'patientCarePlanUploadRequest', patientCarePlanUploadRequest)
            const localVarPath = `/organizations/{org_id}/template`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCarePlanUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List generic care plan templates from an organization.
         * @summary List care plan templates of an organization
         * @param {string} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getTemplates', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/templates`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves notification preferences for a specific user.
         * @summary Get user preferences
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferences: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserPreferences', 'userId', userId)
            const localVarPath = `/user/{user_id}/preferences`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves profile information for a specific user.
         * @summary Get user profile
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProfile', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if an assessment exists without generating an access URL
         * @summary Check if assessment exists
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headAssessment: async (orgId: string, enrollmentId: string, assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('headAssessment', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('headAssessment', 'enrollmentId', enrollmentId)
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('headAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/assessments/{assessment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the photos for a patient enrollment, including provider responses.
         * @summary List patient enrollment photos
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrollmentPhotos: async (orgId: string, enrollmentId: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('listEnrollmentPhotos', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('listEnrollmentPhotos', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/photos`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all predefined action items for an organization.
         * @summary List predefined action items
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPredefinedActions: async (orgId: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('listPredefinedActions', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/predefined-actions`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the current processing status of an enrollment edit.
         * @summary Get enrollment edit status
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} editId Edit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet: async (orgId: string, enrollmentId: string, editId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet', 'enrollmentId', enrollmentId)
            // verify required parameter 'editId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet', 'editId', editId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/edits/{edit_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"edit_id"}}`, encodeURIComponent(String(editId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a unique edit ID and pre-signed S3 URL for uploading enrollment edit data directly to S3.
         * @summary Create enrollment edit and get pre-signed upload URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdEditsPost: async (orgId: string, enrollmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdEditsPost', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdEditsPost', 'enrollmentId', enrollmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/edits`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a pre-signed S3 URL for uploading an enrollment-related file (e.g., incision or medication photo).
         * @summary Get pre-signed URL for patient photo upload
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {PatientPhotoUploadRequest} patientPhotoUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdUploadPost: async (orgId: string, enrollmentId: string, patientPhotoUploadRequest: PatientPhotoUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdUploadPost', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdUploadPost', 'enrollmentId', enrollmentId)
            // verify required parameter 'patientPhotoUploadRequest' is not null or undefined
            assertParamExists('organizationsOrgIdEnrollmentsEnrollmentIdUploadPost', 'patientPhotoUploadRequest', patientPhotoUploadRequest)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/upload`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientPhotoUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a photo for a patient enrollment, including provider responses.
         * @summary Update patient enrollment photo
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {PatientPhoto} patientPhoto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollmentPhoto: async (orgId: string, id: string, enrollmentId: string, patientPhoto: PatientPhoto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateEnrollmentPhoto', 'orgId', orgId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEnrollmentPhoto', 'id', id)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('updateEnrollmentPhoto', 'enrollmentId', enrollmentId)
            // verify required parameter 'patientPhoto' is not null or undefined
            assertParamExists('updateEnrollmentPhoto', 'patientPhoto', patientPhoto)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/photos/{id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientPhoto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register patient or updates an existing patient record TOS for the given organization.
         * @summary Create or update a patient
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: async (patient: Patient, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('updatePatient', 'patient', patient)
            const localVarPath = `/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a patient enrollment\'s action item.
         * @summary Update patient enrollment action item
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {ActionUpdateStatusRequest} actionUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientEnrollmentAction: async (orgId: string, enrollmentId: string, actionId: string, actionUpdateStatusRequest: ActionUpdateStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updatePatientEnrollmentAction', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('updatePatientEnrollmentAction', 'enrollmentId', enrollmentId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updatePatientEnrollmentAction', 'actionId', actionId)
            // verify required parameter 'actionUpdateStatusRequest' is not null or undefined
            assertParamExists('updatePatientEnrollmentAction', 'actionUpdateStatusRequest', actionUpdateStatusRequest)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/actions/{action_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionUpdateStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update patient record by patient ID
         * @summary Update a patient by ID
         * @param {string} patientId 
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientTos: async (patientId: string, patient: Patient, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientTos', 'patientId', patientId)
            // verify required parameter 'patient' is not null or undefined
            assertParamExists('updatePatientTos', 'patient', patient)
            const localVarPath = `/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing pending patient enrollment for the given organization.
         * @summary Update pending patient enrollment in an organization
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePendingPatientEnrollment: async (orgId: string, pendingPatientEnrollmentId: string, pendingPatientEnrollment: PendingPatientEnrollment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updatePendingPatientEnrollment', 'orgId', orgId)
            // verify required parameter 'pendingPatientEnrollmentId' is not null or undefined
            assertParamExists('updatePendingPatientEnrollment', 'pendingPatientEnrollmentId', pendingPatientEnrollmentId)
            // verify required parameter 'pendingPatientEnrollment' is not null or undefined
            assertParamExists('updatePendingPatientEnrollment', 'pendingPatientEnrollment', pendingPatientEnrollment)
            const localVarPath = `/organizations/{org_id}/pending_patient_enrollments/{pending_patient_enrollment_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"pending_patient_enrollment_id"}}`, encodeURIComponent(String(pendingPatientEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pendingPatientEnrollment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing predefined action item.
         * @summary Update a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePredefinedAction: async (orgId: string, actionId: string, predefinedAction: PredefinedAction, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updatePredefinedAction', 'orgId', orgId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updatePredefinedAction', 'actionId', actionId)
            // verify required parameter 'predefinedAction' is not null or undefined
            assertParamExists('updatePredefinedAction', 'predefinedAction', predefinedAction)
            const localVarPath = `/organizations/{org_id}/predefined-actions/{action_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predefinedAction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates notification preferences for a specific user.
         * @summary Update user preferences
         * @param {string} userId User ID
         * @param {UserPreferences} userPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreferences: async (userId: string, userPreferences: UserPreferences, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPreferences', 'userId', userId)
            // verify required parameter 'userPreferences' is not null or undefined
            assertParamExists('updateUserPreferences', 'userPreferences', userPreferences)
            const localVarPath = `/user/{user_id}/preferences`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPreferences, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a 302 redirect to the assessment access URL for direct browser access
         * @summary Get assessment access URL with redirect
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAssessment: async (orgId: string, enrollmentId: string, assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('viewAssessment', 'orgId', orgId)
            // verify required parameter 'enrollmentId' is not null or undefined
            assertParamExists('viewAssessment', 'enrollmentId', enrollmentId)
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('viewAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/organizations/{org_id}/enrollments/{enrollment_id}/assessments/{assessment_id}/url`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"enrollment_id"}}`, encodeURIComponent(String(enrollmentId)))
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CognitoAuthorizer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows administrators to reset a user\'s password. Requires admin role and organization membership validation.
         * @summary Admin password reset for user
         * @param {string} userId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPasswordReset(userId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPasswordReset200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPasswordReset(userId, adminPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new patient enrollment w/ care plan details for an organization.
         * @summary Create care plan specific to patient enrollment
         * @param {string} orgId Organization ID
         * @param {CreatePatientEnrollmentRequest} createPatientEnrollmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientEnrollment(orgId: string, createPatientEnrollmentRequest: CreatePatientEnrollmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Enrollment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientEnrollment(orgId, createPatientEnrollmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create pending patient enrollment saving patient details & partial enrollment details.
         * @summary Create a pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPendingPatientEnrollment(orgId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingPatientEnrollment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPendingPatientEnrollment(orgId, pendingPatientEnrollment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPendingPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new predefined action item for an organization.
         * @summary Create a predefined action item
         * @param {string} orgId Organization ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPredefinedAction(orgId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPredefinedAction(orgId, predefinedAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createPredefinedAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create upload request
         * @param {string} orgId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUploadRequest(orgId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUploadRequest(orgId, uploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUploadRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a notification for an organization by its ID.
         * @summary Delete organization notification
         * @param {string} orgId Organization ID
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrgNotification(orgId: string, notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrgNotification(orgId, notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOrgNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel or delete an existing patient enrollment for the given organization.
         * @summary Cancel a current enrollment
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientEnrollment(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientEnrollment(orgId, enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete items from an enrollment for action, event, broadcast
         * @summary Delete patient enrollment items Action, Event, Broadcast
         * @param {string} orgId 
         * @param {string} enrollmentId 
         * @param {BulkDeleteItemsRequest} bulkDeleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientEnrollmentItems(orgId: string, enrollmentId: string, bulkDeleteItemsRequest: BulkDeleteItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientEnrollmentItems(orgId, enrollmentId, bulkDeleteItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePatientEnrollmentItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes/Removes a pending patient enrollment by it ID.
         * @summary Delete/Remove pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePendingPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a predefined action item from an organization.
         * @summary Delete a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePredefinedAction(orgId, actionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deletePredefinedAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Download files as CSV and send email notification
         * @param {string} orgId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFiles(orgId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadFiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFiles(orgId, downloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a Signed URL to download the prepared export CSV file for the specified organization.
         * @summary Get a link to the generated CSV file
         * @param {string} orgId 
         * @param {string} downloadId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFilesLink(orgId: string, downloadId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadFilesLink200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFilesLink(orgId, downloadId, downloadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFilesLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves assessment details and generates a temporary access URL for LainaHealth assessment completion
         * @summary Get assessment details with access URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssessment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessment(orgId, enrollmentId, assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Get an Embed URL for an organization\'s dashboard
         * @param {string} orgId 
         * @param {GetDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardEmbedUrl(orgId: string, slug: GetDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardEmbedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardEmbedUrl(orgId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDashboardEmbedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a Quicksight Embed URL for an enrollment scope
         * @summary Get an Embed URL for an Enrollment\'s dashboard
         * @param {string} enrollmentId 
         * @param {GetEnrollmentDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrollmentDashboardEmbedUrl(enrollmentId: string, slug: GetEnrollmentDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardEmbedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrollmentDashboardEmbedUrl(enrollmentId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEnrollmentDashboardEmbedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single photo for a patient enrollment by photo ID.
         * @summary Get patient enrollment photo by ID
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientPhoto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrollmentPhoto(orgId, id, enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEnrollmentPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Profile
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrg(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrg(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves notifications for an organization.
         * @summary List organization notifications
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgNotifications(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgNotifications(orgId, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOrgNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single patient record by patient ID
         * @summary Get patient by patient ID
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatient(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatient(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a patient enrollment by enrollment_id
         * @summary Get patient enrollment by enrollment_id
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientEnrollment(enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Enrollment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientEnrollment(enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a patient enrollment\'s action item by action_id from an organization.
         * @summary Get an enrollment action item by action_id
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentActionItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientEnrollmentAction(orgId, enrollmentId, actionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientEnrollmentAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List a patient enrollment\'s action items from an organization, filter by status or date.
         * @summary List of an enrollment\'s action items
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {GetPatientEnrollmentActionsStatusEnum} [status] Filter actions by status
         * @param {string} [date] Filter actions by date (YYYY-MM-DD)
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientEnrollmentActions(orgId: string, enrollmentId: string, status?: GetPatientEnrollmentActionsStatusEnum, date?: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrollmentActionItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientEnrollmentActions(orgId, enrollmentId, status, date, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientEnrollmentActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of patient enrollments from an org. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary Get list of patient enrollments
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter enrollments by one or more surgeon IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientEnrollments(orgId: string, cursor?: string, q?: string, surgeonNpi?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientEnrollment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientEnrollments(orgId, cursor, q, surgeonNpi, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientEnrollments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an AWS QuickSight embed URL for viewing a patient\'s post-operative metrics.
         * @summary Get patient post-op metrics embed URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPostopMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOpMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPostopMetrics(orgId, enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientPostopMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest Patient-Reported Outcome Measures (PROMS) survey data for a specific patient enrollment, including KOOSJR, HOOSJR, ASES, ROM, and VAS scores.
         * @summary Get patient PROMS metrics
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPromsMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientsPromsMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPromsMetrics(orgId, enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatientPromsMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of patients for an organization.
         * @summary List patients in an organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatients(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Patient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatients(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a pending patient enrollment for an organization.
         * @summary Get a pending patient enrollment by pending_patient_enrollment_id
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingPatientEnrollment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves pending patient enrollments for an organization. These are the patients w/o surgery_date or missing other enrollment details. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary List organization pending patient enrollments
         * @param {string} orgId Organization ID
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter by one or more surgeon IDs
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingPatientEnrollments(orgId: string, q?: string, surgeonNpi?: Array<string>, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingPatientEnrollment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingPatientEnrollments(orgId, q, surgeonNpi, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingPatientEnrollments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific predefined action item by its ID.
         * @summary Get a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredefinedAction(orgId, actionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPredefinedAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of procedures for an organization.
         * @summary List procedures in an organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcedures(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcedures(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getProcedures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List metrics for uploaded case data for a surgeon in an organization
         * @summary List surgeon case upload metrics
         * @param {string} orgId 
         * @param {string} surgeonNpi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurgeonMetrics(orgId: string, surgeonNpi: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSurgeonMetrics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurgeonMetrics(orgId, surgeonNpi, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSurgeonMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of surgeons for an organization.
         * @summary List surgeons in an organization
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurgeons(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Surgeon>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurgeons(orgId, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSurgeons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Combined list, filter, and search endpoint for surgeries within an organization. Supports filters like name, date of birth, location, procedure type, surgery phase, and active status. Pagination is supported using `cursor`.
         * @summary List surgeries in an organization
         * @param {string} orgId 
         * @param {string} [q] Search query to filter results by
         * @param {string} [location] 
         * @param {GetSurgeriesProcedureTypeEnum} [procedureType] 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurgeries(orgId: string, q?: string, location?: string, procedureType?: GetSurgeriesProcedureTypeEnum, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Surgery>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurgeries(orgId, q, location, procedureType, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSurgeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single surgery record by case ID within a specific organization.
         * @summary Get surgery by case ID
         * @param {string} orgId 
         * @param {string} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurgery(orgId: string, caseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Surgery>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurgery(orgId, caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSurgery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get generic care plan template for the given organization.
         * @summary Get generic care plan template of an organization
         * @param {string} orgId Organization ID
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(orgId: string, templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(orgId, templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a pre-signed S3 URL for creating a bespoke patient care plan based on a generic template.
         * @summary Get pre-signed URL to upload patient care plan from base template
         * @param {string} orgId Organization ID
         * @param {PatientCarePlanUploadRequest} patientCarePlanUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateUploadRequest(orgId: string, patientCarePlanUploadRequest: PatientCarePlanUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientCarePlanUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateUploadRequest(orgId, patientCarePlanUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTemplateUploadRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List generic care plan templates from an organization.
         * @summary List care plan templates of an organization
         * @param {string} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplates(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GenericTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplates(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves notification preferences for a specific user.
         * @summary Get user preferences
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreferences(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreferences(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves profile information for a specific user.
         * @summary Get user profile
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if an assessment exists without generating an access URL
         * @summary Check if assessment exists
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async headAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.headAssessment(orgId, enrollmentId, assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.headAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the photos for a patient enrollment, including provider responses.
         * @summary List patient enrollment photos
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnrollmentPhotos(orgId: string, enrollmentId: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientPhoto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnrollmentPhotos(orgId, enrollmentId, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listEnrollmentPhotos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all predefined action items for an organization.
         * @summary List predefined action items
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPredefinedActions(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PredefinedAction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPredefinedActions(orgId, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listPredefinedActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the current processing status of an enrollment edit.
         * @summary Get enrollment edit status
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} editId Edit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId: string, enrollmentId: string, editId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentEdit>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId, enrollmentId, editId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a unique edit ID and pre-signed S3 URL for uploading enrollment edit data directly to S3.
         * @summary Create enrollment edit and get pre-signed upload URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrollmentEditUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId, enrollmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrgIdEnrollmentsEnrollmentIdEditsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a pre-signed S3 URL for uploading an enrollment-related file (e.g., incision or medication photo).
         * @summary Get pre-signed URL for patient photo upload
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {PatientPhotoUploadRequest} patientPhotoUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId: string, enrollmentId: string, patientPhotoUploadRequest: PatientPhotoUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientPhotoUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId, enrollmentId, patientPhotoUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.organizationsOrgIdEnrollmentsEnrollmentIdUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a photo for a patient enrollment, including provider responses.
         * @summary Update patient enrollment photo
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {PatientPhoto} patientPhoto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, patientPhoto: PatientPhoto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnrollmentPhoto(orgId, id, enrollmentId, patientPhoto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateEnrollmentPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register patient or updates an existing patient record TOS for the given organization.
         * @summary Create or update a patient
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatient(patient: Patient, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatient(patient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a patient enrollment\'s action item.
         * @summary Update patient enrollment action item
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {ActionUpdateStatusRequest} actionUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, actionUpdateStatusRequest: ActionUpdateStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientEnrollmentAction(orgId, enrollmentId, actionId, actionUpdateStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePatientEnrollmentAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update patient record by patient ID
         * @summary Update a patient by ID
         * @param {string} patientId 
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientTos(patientId: string, patient: Patient, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientTos(patientId, patient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePatientTos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing pending patient enrollment for the given organization.
         * @summary Update pending patient enrollment in an organization
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, pendingPatientEnrollment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePendingPatientEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing predefined action item.
         * @summary Update a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePredefinedAction(orgId: string, actionId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredefinedAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePredefinedAction(orgId, actionId, predefinedAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePredefinedAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates notification preferences for a specific user.
         * @summary Update user preferences
         * @param {string} userId User ID
         * @param {UserPreferences} userPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPreferences(userId: string, userPreferences: UserPreferences, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPreferences(userId, userPreferences, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a 302 redirect to the assessment access URL for direct browser access
         * @summary Get assessment access URL with redirect
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewAssessment(orgId, enrollmentId, assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.viewAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Allows administrators to reset a user\'s password. Requires admin role and organization membership validation.
         * @summary Admin password reset for user
         * @param {string} userId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPasswordReset(userId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPasswordReset200Response> {
            return localVarFp.adminPasswordReset(userId, adminPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new patient enrollment w/ care plan details for an organization.
         * @summary Create care plan specific to patient enrollment
         * @param {string} orgId Organization ID
         * @param {CreatePatientEnrollmentRequest} createPatientEnrollmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientEnrollment(orgId: string, createPatientEnrollmentRequest: CreatePatientEnrollmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Enrollment> {
            return localVarFp.createPatientEnrollment(orgId, createPatientEnrollmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create pending patient enrollment saving patient details & partial enrollment details.
         * @summary Create a pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPendingPatientEnrollment(orgId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig): AxiosPromise<PendingPatientEnrollment> {
            return localVarFp.createPendingPatientEnrollment(orgId, pendingPatientEnrollment, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new predefined action item for an organization.
         * @summary Create a predefined action item
         * @param {string} orgId Organization ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedAction(orgId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig): AxiosPromise<PredefinedAction> {
            return localVarFp.createPredefinedAction(orgId, predefinedAction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create upload request
         * @param {string} orgId 
         * @param {UploadRequest} uploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadRequest(orgId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadResponse> {
            return localVarFp.createUploadRequest(orgId, uploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a notification for an organization by its ID.
         * @summary Delete organization notification
         * @param {string} orgId Organization ID
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgNotification(orgId: string, notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrgNotification(orgId, notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel or delete an existing patient enrollment for the given organization.
         * @summary Cancel a current enrollment
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientEnrollment(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientEnrollment(orgId, enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete items from an enrollment for action, event, broadcast
         * @summary Delete patient enrollment items Action, Event, Broadcast
         * @param {string} orgId 
         * @param {string} enrollmentId 
         * @param {BulkDeleteItemsRequest} bulkDeleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientEnrollmentItems(orgId: string, enrollmentId: string, bulkDeleteItemsRequest: BulkDeleteItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientEnrollmentItems(orgId, enrollmentId, bulkDeleteItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes/Removes a pending patient enrollment by it ID.
         * @summary Delete/Remove pending patient enrollment
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a predefined action item from an organization.
         * @summary Delete a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePredefinedAction(orgId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Download files as CSV and send email notification
         * @param {string} orgId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFiles(orgId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<DownloadFiles200Response> {
            return localVarFp.downloadFiles(orgId, downloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a Signed URL to download the prepared export CSV file for the specified organization.
         * @summary Get a link to the generated CSV file
         * @param {string} orgId 
         * @param {string} downloadId 
         * @param {DownloadRequest} downloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFilesLink(orgId: string, downloadId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<DownloadFilesLink200Response> {
            return localVarFp.downloadFilesLink(orgId, downloadId, downloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves assessment details and generates a temporary access URL for LainaHealth assessment completion
         * @summary Get assessment details with access URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAssessment200Response> {
            return localVarFp.getAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
         * @summary Get an Embed URL for an organization\'s dashboard
         * @param {string} orgId 
         * @param {GetDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl(orgId: string, slug: GetDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetDashboardEmbedUrl200Response> {
            return localVarFp.getDashboardEmbedUrl(orgId, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a Quicksight Embed URL for an enrollment scope
         * @summary Get an Embed URL for an Enrollment\'s dashboard
         * @param {string} enrollmentId 
         * @param {GetEnrollmentDashboardEmbedUrlSlugEnum} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentDashboardEmbedUrl(enrollmentId: string, slug: GetEnrollmentDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetDashboardEmbedUrl200Response> {
            return localVarFp.getEnrollmentDashboardEmbedUrl(enrollmentId, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single photo for a patient enrollment by photo ID.
         * @summary Get patient enrollment photo by ID
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientPhoto> {
            return localVarFp.getEnrollmentPhoto(orgId, id, enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Profile
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Organization> {
            return localVarFp.getOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves notifications for an organization.
         * @summary List organization notifications
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgNotifications(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>> {
            return localVarFp.getOrgNotifications(orgId, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single patient record by patient ID
         * @summary Get patient by patient ID
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.getPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a patient enrollment by enrollment_id
         * @summary Get patient enrollment by enrollment_id
         * @param {string} enrollmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollment(enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Enrollment> {
            return localVarFp.getPatientEnrollment(enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a patient enrollment\'s action item by action_id from an organization.
         * @summary Get an enrollment action item by action_id
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnrollmentActionItem> {
            return localVarFp.getPatientEnrollmentAction(orgId, enrollmentId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * List a patient enrollment\'s action items from an organization, filter by status or date.
         * @summary List of an enrollment\'s action items
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {GetPatientEnrollmentActionsStatusEnum} [status] Filter actions by status
         * @param {string} [date] Filter actions by date (YYYY-MM-DD)
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollmentActions(orgId: string, enrollmentId: string, status?: GetPatientEnrollmentActionsStatusEnum, date?: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnrollmentActionItem>> {
            return localVarFp.getPatientEnrollmentActions(orgId, enrollmentId, status, date, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List of patient enrollments from an org. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary Get list of patient enrollments
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter enrollments by one or more surgeon IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientEnrollments(orgId: string, cursor?: string, q?: string, surgeonNpi?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientEnrollment>> {
            return localVarFp.getPatientEnrollments(orgId, cursor, q, surgeonNpi, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an AWS QuickSight embed URL for viewing a patient\'s post-operative metrics.
         * @summary Get patient post-op metrics embed URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPostopMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<PostOpMetricsResponse> {
            return localVarFp.getPatientPostopMetrics(orgId, enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest Patient-Reported Outcome Measures (PROMS) survey data for a specific patient enrollment, including KOOSJR, HOOSJR, ASES, ROM, and VAS scores.
         * @summary Get patient PROMS metrics
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPromsMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientsPromsMetric>> {
            return localVarFp.getPatientPromsMetrics(orgId, enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of patients for an organization.
         * @summary List patients in an organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatients(options?: RawAxiosRequestConfig): AxiosPromise<Array<Patient>> {
            return localVarFp.getPatients(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a pending patient enrollment for an organization.
         * @summary Get a pending patient enrollment by pending_patient_enrollment_id
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<PendingPatientEnrollment> {
            return localVarFp.getPendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves pending patient enrollments for an organization. These are the patients w/o surgery_date or missing other enrollment details. Supports filtering by surgeons and searching by patient name/MRN/dob.
         * @summary List organization pending patient enrollments
         * @param {string} orgId Organization ID
         * @param {string} [q] Search query to filter by (patient name/mrn/dob)
         * @param {Array<string>} [surgeonNpi] Filter by one or more surgeon IDs
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPatientEnrollments(orgId: string, q?: string, surgeonNpi?: Array<string>, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PendingPatientEnrollment>> {
            return localVarFp.getPendingPatientEnrollments(orgId, q, surgeonNpi, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific predefined action item by its ID.
         * @summary Get a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig): AxiosPromise<PredefinedAction> {
            return localVarFp.getPredefinedAction(orgId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of procedures for an organization.
         * @summary List procedures in an organization
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcedures(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getProcedures(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * List metrics for uploaded case data for a surgeon in an organization
         * @summary List surgeon case upload metrics
         * @param {string} orgId 
         * @param {string} surgeonNpi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeonMetrics(orgId: string, surgeonNpi: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSurgeonMetrics200Response> {
            return localVarFp.getSurgeonMetrics(orgId, surgeonNpi, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of surgeons for an organization.
         * @summary List surgeons in an organization
         * @param {string} orgId 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeons(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Surgeon>> {
            return localVarFp.getSurgeons(orgId, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Combined list, filter, and search endpoint for surgeries within an organization. Supports filters like name, date of birth, location, procedure type, surgery phase, and active status. Pagination is supported using `cursor`.
         * @summary List surgeries in an organization
         * @param {string} orgId 
         * @param {string} [q] Search query to filter results by
         * @param {string} [location] 
         * @param {GetSurgeriesProcedureTypeEnum} [procedureType] 
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgeries(orgId: string, q?: string, location?: string, procedureType?: GetSurgeriesProcedureTypeEnum, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Surgery>> {
            return localVarFp.getSurgeries(orgId, q, location, procedureType, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single surgery record by case ID within a specific organization.
         * @summary Get surgery by case ID
         * @param {string} orgId 
         * @param {string} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurgery(orgId: string, caseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Surgery> {
            return localVarFp.getSurgery(orgId, caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get generic care plan template for the given organization.
         * @summary Get generic care plan template of an organization
         * @param {string} orgId Organization ID
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(orgId: string, templateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericTemplate> {
            return localVarFp.getTemplate(orgId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a pre-signed S3 URL for creating a bespoke patient care plan based on a generic template.
         * @summary Get pre-signed URL to upload patient care plan from base template
         * @param {string} orgId Organization ID
         * @param {PatientCarePlanUploadRequest} patientCarePlanUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUploadRequest(orgId: string, patientCarePlanUploadRequest: PatientCarePlanUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientCarePlanUploadResponse> {
            return localVarFp.getTemplateUploadRequest(orgId, patientCarePlanUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List generic care plan templates from an organization.
         * @summary List care plan templates of an organization
         * @param {string} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GenericTemplate>> {
            return localVarFp.getTemplates(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves notification preferences for a specific user.
         * @summary Get user preferences
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreferences(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPreferences> {
            return localVarFp.getUserPreferences(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves profile information for a specific user.
         * @summary Get user profile
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProfile> {
            return localVarFp.getUserProfile(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if an assessment exists without generating an access URL
         * @summary Check if assessment exists
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        headAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.headAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the photos for a patient enrollment, including provider responses.
         * @summary List patient enrollment photos
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrollmentPhotos(orgId: string, enrollmentId: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PatientPhoto>> {
            return localVarFp.listEnrollmentPhotos(orgId, enrollmentId, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all predefined action items for an organization.
         * @summary List predefined action items
         * @param {string} orgId Organization ID
         * @param {string} [cursor] Page cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPredefinedActions(orgId: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PredefinedAction>> {
            return localVarFp.listPredefinedActions(orgId, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the current processing status of an enrollment edit.
         * @summary Get enrollment edit status
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} editId Edit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId: string, enrollmentId: string, editId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnrollmentEdit> {
            return localVarFp.organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId, enrollmentId, editId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a unique edit ID and pre-signed S3 URL for uploading enrollment edit data directly to S3.
         * @summary Create enrollment edit and get pre-signed upload URL
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnrollmentEditUploadResponse> {
            return localVarFp.organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId, enrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a pre-signed S3 URL for uploading an enrollment-related file (e.g., incision or medication photo).
         * @summary Get pre-signed URL for patient photo upload
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {PatientPhotoUploadRequest} patientPhotoUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId: string, enrollmentId: string, patientPhotoUploadRequest: PatientPhotoUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatientPhotoUploadResponse> {
            return localVarFp.organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId, enrollmentId, patientPhotoUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a photo for a patient enrollment, including provider responses.
         * @summary Update patient enrollment photo
         * @param {string} orgId Organization ID
         * @param {string} id Enrollment Photo ID
         * @param {string} enrollmentId 
         * @param {PatientPhoto} patientPhoto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, patientPhoto: PatientPhoto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEnrollmentPhoto(orgId, id, enrollmentId, patientPhoto, options).then((request) => request(axios, basePath));
        },
        /**
         * Register patient or updates an existing patient record TOS for the given organization.
         * @summary Create or update a patient
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient(patient: Patient, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.updatePatient(patient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a patient enrollment\'s action item.
         * @summary Update patient enrollment action item
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} actionId Action ID
         * @param {ActionUpdateStatusRequest} actionUpdateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, actionUpdateStatusRequest: ActionUpdateStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePatientEnrollmentAction(orgId, enrollmentId, actionId, actionUpdateStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update patient record by patient ID
         * @summary Update a patient by ID
         * @param {string} patientId 
         * @param {Patient} patient 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientTos(patientId: string, patient: Patient, options?: RawAxiosRequestConfig): AxiosPromise<Patient> {
            return localVarFp.updatePatientTos(patientId, patient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing pending patient enrollment for the given organization.
         * @summary Update pending patient enrollment in an organization
         * @param {string} orgId Organization ID
         * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
         * @param {PendingPatientEnrollment} pendingPatientEnrollment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, pendingPatientEnrollment, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing predefined action item.
         * @summary Update a predefined action item
         * @param {string} orgId Organization ID
         * @param {string} actionId Predefined Action ID
         * @param {PredefinedAction} predefinedAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePredefinedAction(orgId: string, actionId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig): AxiosPromise<PredefinedAction> {
            return localVarFp.updatePredefinedAction(orgId, actionId, predefinedAction, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates notification preferences for a specific user.
         * @summary Update user preferences
         * @param {string} userId User ID
         * @param {UserPreferences} userPreferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreferences(userId: string, userPreferences: UserPreferences, options?: RawAxiosRequestConfig): AxiosPromise<UserPreferences> {
            return localVarFp.updateUserPreferences(userId, userPreferences, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a 302 redirect to the assessment access URL for direct browser access
         * @summary Get assessment access URL with redirect
         * @param {string} orgId Organization ID
         * @param {string} enrollmentId Enrollment ID
         * @param {string} assessmentId Assessment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Allows administrators to reset a user\'s password. Requires admin role and organization membership validation.
     * @summary Admin password reset for user
     * @param {string} userId 
     * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminPasswordReset(userId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminPasswordReset(userId, adminPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new patient enrollment w/ care plan details for an organization.
     * @summary Create care plan specific to patient enrollment
     * @param {string} orgId Organization ID
     * @param {CreatePatientEnrollmentRequest} createPatientEnrollmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPatientEnrollment(orgId: string, createPatientEnrollmentRequest: CreatePatientEnrollmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPatientEnrollment(orgId, createPatientEnrollmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create pending patient enrollment saving patient details & partial enrollment details.
     * @summary Create a pending patient enrollment
     * @param {string} orgId Organization ID
     * @param {PendingPatientEnrollment} pendingPatientEnrollment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPendingPatientEnrollment(orgId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPendingPatientEnrollment(orgId, pendingPatientEnrollment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new predefined action item for an organization.
     * @summary Create a predefined action item
     * @param {string} orgId Organization ID
     * @param {PredefinedAction} predefinedAction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPredefinedAction(orgId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPredefinedAction(orgId, predefinedAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create upload request
     * @param {string} orgId 
     * @param {UploadRequest} uploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUploadRequest(orgId: string, uploadRequest: UploadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUploadRequest(orgId, uploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a notification for an organization by its ID.
     * @summary Delete organization notification
     * @param {string} orgId Organization ID
     * @param {string} notificationId Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOrgNotification(orgId: string, notificationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOrgNotification(orgId, notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel or delete an existing patient enrollment for the given organization.
     * @summary Cancel a current enrollment
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePatientEnrollment(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePatientEnrollment(orgId, enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete items from an enrollment for action, event, broadcast
     * @summary Delete patient enrollment items Action, Event, Broadcast
     * @param {string} orgId 
     * @param {string} enrollmentId 
     * @param {BulkDeleteItemsRequest} bulkDeleteItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePatientEnrollmentItems(orgId: string, enrollmentId: string, bulkDeleteItemsRequest: BulkDeleteItemsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePatientEnrollmentItems(orgId, enrollmentId, bulkDeleteItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes/Removes a pending patient enrollment by it ID.
     * @summary Delete/Remove pending patient enrollment
     * @param {string} orgId Organization ID
     * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a predefined action item from an organization.
     * @summary Delete a predefined action item
     * @param {string} orgId Organization ID
     * @param {string} actionId Predefined Action ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePredefinedAction(orgId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
     * @summary Download files as CSV and send email notification
     * @param {string} orgId 
     * @param {DownloadRequest} downloadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFiles(orgId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFiles(orgId, downloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a Signed URL to download the prepared export CSV file for the specified organization.
     * @summary Get a link to the generated CSV file
     * @param {string} orgId 
     * @param {string} downloadId 
     * @param {DownloadRequest} downloadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFilesLink(orgId: string, downloadId: string, downloadRequest: DownloadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFilesLink(orgId, downloadId, downloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves assessment details and generates a temporary access URL for LainaHealth assessment completion
     * @summary Get assessment details with access URL
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} assessmentId Assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a CSV file containing files metadata for the specified organization, triggers sending an email notification once the CSV is ready.
     * @summary Get an Embed URL for an organization\'s dashboard
     * @param {string} orgId 
     * @param {GetDashboardEmbedUrlSlugEnum} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDashboardEmbedUrl(orgId: string, slug: GetDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDashboardEmbedUrl(orgId, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a Quicksight Embed URL for an enrollment scope
     * @summary Get an Embed URL for an Enrollment\'s dashboard
     * @param {string} enrollmentId 
     * @param {GetEnrollmentDashboardEmbedUrlSlugEnum} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEnrollmentDashboardEmbedUrl(enrollmentId: string, slug: GetEnrollmentDashboardEmbedUrlSlugEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEnrollmentDashboardEmbedUrl(enrollmentId, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single photo for a patient enrollment by photo ID.
     * @summary Get patient enrollment photo by ID
     * @param {string} orgId Organization ID
     * @param {string} id Enrollment Photo ID
     * @param {string} enrollmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEnrollmentPhoto(orgId, id, enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Profile
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrg(orgId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves notifications for an organization.
     * @summary List organization notifications
     * @param {string} orgId Organization ID
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrgNotifications(orgId: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrgNotifications(orgId, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single patient record by patient ID
     * @summary Get patient by patient ID
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatient(patientId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a patient enrollment by enrollment_id
     * @summary Get patient enrollment by enrollment_id
     * @param {string} enrollmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientEnrollment(enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientEnrollment(enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a patient enrollment\'s action item by action_id from an organization.
     * @summary Get an enrollment action item by action_id
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} actionId Action ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientEnrollmentAction(orgId, enrollmentId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List a patient enrollment\'s action items from an organization, filter by status or date.
     * @summary List of an enrollment\'s action items
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {GetPatientEnrollmentActionsStatusEnum} [status] Filter actions by status
     * @param {string} [date] Filter actions by date (YYYY-MM-DD)
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientEnrollmentActions(orgId: string, enrollmentId: string, status?: GetPatientEnrollmentActionsStatusEnum, date?: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientEnrollmentActions(orgId, enrollmentId, status, date, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of patient enrollments from an org. Supports filtering by surgeons and searching by patient name/MRN/dob.
     * @summary Get list of patient enrollments
     * @param {string} orgId 
     * @param {string} [cursor] Page cursor
     * @param {string} [q] Search query to filter by (patient name/mrn/dob)
     * @param {Array<string>} [surgeonNpi] Filter enrollments by one or more surgeon IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientEnrollments(orgId: string, cursor?: string, q?: string, surgeonNpi?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientEnrollments(orgId, cursor, q, surgeonNpi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an AWS QuickSight embed URL for viewing a patient\'s post-operative metrics.
     * @summary Get patient post-op metrics embed URL
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientPostopMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientPostopMetrics(orgId, enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest Patient-Reported Outcome Measures (PROMS) survey data for a specific patient enrollment, including KOOSJR, HOOSJR, ASES, ROM, and VAS scores.
     * @summary Get patient PROMS metrics
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatientPromsMetrics(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatientPromsMetrics(orgId, enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of patients for an organization.
     * @summary List patients in an organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPatients(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPatients(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a pending patient enrollment for an organization.
     * @summary Get a pending patient enrollment by pending_patient_enrollment_id
     * @param {string} orgId Organization ID
     * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingPatientEnrollment(orgId, pendingPatientEnrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves pending patient enrollments for an organization. These are the patients w/o surgery_date or missing other enrollment details. Supports filtering by surgeons and searching by patient name/MRN/dob.
     * @summary List organization pending patient enrollments
     * @param {string} orgId Organization ID
     * @param {string} [q] Search query to filter by (patient name/mrn/dob)
     * @param {Array<string>} [surgeonNpi] Filter by one or more surgeon IDs
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingPatientEnrollments(orgId: string, q?: string, surgeonNpi?: Array<string>, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingPatientEnrollments(orgId, q, surgeonNpi, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific predefined action item by its ID.
     * @summary Get a predefined action item
     * @param {string} orgId Organization ID
     * @param {string} actionId Predefined Action ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPredefinedAction(orgId: string, actionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPredefinedAction(orgId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of procedures for an organization.
     * @summary List procedures in an organization
     * @param {string} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getProcedures(orgId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getProcedures(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List metrics for uploaded case data for a surgeon in an organization
     * @summary List surgeon case upload metrics
     * @param {string} orgId 
     * @param {string} surgeonNpi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSurgeonMetrics(orgId: string, surgeonNpi: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSurgeonMetrics(orgId, surgeonNpi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of surgeons for an organization.
     * @summary List surgeons in an organization
     * @param {string} orgId 
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSurgeons(orgId: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSurgeons(orgId, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Combined list, filter, and search endpoint for surgeries within an organization. Supports filters like name, date of birth, location, procedure type, surgery phase, and active status. Pagination is supported using `cursor`.
     * @summary List surgeries in an organization
     * @param {string} orgId 
     * @param {string} [q] Search query to filter results by
     * @param {string} [location] 
     * @param {GetSurgeriesProcedureTypeEnum} [procedureType] 
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSurgeries(orgId: string, q?: string, location?: string, procedureType?: GetSurgeriesProcedureTypeEnum, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSurgeries(orgId, q, location, procedureType, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single surgery record by case ID within a specific organization.
     * @summary Get surgery by case ID
     * @param {string} orgId 
     * @param {string} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSurgery(orgId: string, caseId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSurgery(orgId, caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get generic care plan template for the given organization.
     * @summary Get generic care plan template of an organization
     * @param {string} orgId Organization ID
     * @param {string} templateId Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTemplate(orgId: string, templateId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTemplate(orgId, templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a pre-signed S3 URL for creating a bespoke patient care plan based on a generic template.
     * @summary Get pre-signed URL to upload patient care plan from base template
     * @param {string} orgId Organization ID
     * @param {PatientCarePlanUploadRequest} patientCarePlanUploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTemplateUploadRequest(orgId: string, patientCarePlanUploadRequest: PatientCarePlanUploadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTemplateUploadRequest(orgId, patientCarePlanUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List generic care plan templates from an organization.
     * @summary List care plan templates of an organization
     * @param {string} orgId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTemplates(orgId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTemplates(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves notification preferences for a specific user.
     * @summary Get user preferences
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserPreferences(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserPreferences(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves profile information for a specific user.
     * @summary Get user profile
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserProfile(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserProfile(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if an assessment exists without generating an access URL
     * @summary Check if assessment exists
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} assessmentId Assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public headAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).headAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the photos for a patient enrollment, including provider responses.
     * @summary List patient enrollment photos
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listEnrollmentPhotos(orgId: string, enrollmentId: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listEnrollmentPhotos(orgId, enrollmentId, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all predefined action items for an organization.
     * @summary List predefined action items
     * @param {string} orgId Organization ID
     * @param {string} [cursor] Page cursor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listPredefinedActions(orgId: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listPredefinedActions(orgId, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the current processing status of an enrollment edit.
     * @summary Get enrollment edit status
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} editId Edit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId: string, enrollmentId: string, editId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrgIdEnrollmentsEnrollmentIdEditsEditIdGet(orgId, enrollmentId, editId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a unique edit ID and pre-signed S3 URL for uploading enrollment edit data directly to S3.
     * @summary Create enrollment edit and get pre-signed upload URL
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId: string, enrollmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrgIdEnrollmentsEnrollmentIdEditsPost(orgId, enrollmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a pre-signed S3 URL for uploading an enrollment-related file (e.g., incision or medication photo).
     * @summary Get pre-signed URL for patient photo upload
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {PatientPhotoUploadRequest} patientPhotoUploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId: string, enrollmentId: string, patientPhotoUploadRequest: PatientPhotoUploadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationsOrgIdEnrollmentsEnrollmentIdUploadPost(orgId, enrollmentId, patientPhotoUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a photo for a patient enrollment, including provider responses.
     * @summary Update patient enrollment photo
     * @param {string} orgId Organization ID
     * @param {string} id Enrollment Photo ID
     * @param {string} enrollmentId 
     * @param {PatientPhoto} patientPhoto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEnrollmentPhoto(orgId: string, id: string, enrollmentId: string, patientPhoto: PatientPhoto, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEnrollmentPhoto(orgId, id, enrollmentId, patientPhoto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register patient or updates an existing patient record TOS for the given organization.
     * @summary Create or update a patient
     * @param {Patient} patient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePatient(patient: Patient, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePatient(patient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a patient enrollment\'s action item.
     * @summary Update patient enrollment action item
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} actionId Action ID
     * @param {ActionUpdateStatusRequest} actionUpdateStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePatientEnrollmentAction(orgId: string, enrollmentId: string, actionId: string, actionUpdateStatusRequest: ActionUpdateStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePatientEnrollmentAction(orgId, enrollmentId, actionId, actionUpdateStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update patient record by patient ID
     * @summary Update a patient by ID
     * @param {string} patientId 
     * @param {Patient} patient 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePatientTos(patientId: string, patient: Patient, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePatientTos(patientId, patient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing pending patient enrollment for the given organization.
     * @summary Update pending patient enrollment in an organization
     * @param {string} orgId Organization ID
     * @param {string} pendingPatientEnrollmentId Pending Patient Enrollment ID
     * @param {PendingPatientEnrollment} pendingPatientEnrollment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePendingPatientEnrollment(orgId: string, pendingPatientEnrollmentId: string, pendingPatientEnrollment: PendingPatientEnrollment, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePendingPatientEnrollment(orgId, pendingPatientEnrollmentId, pendingPatientEnrollment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing predefined action item.
     * @summary Update a predefined action item
     * @param {string} orgId Organization ID
     * @param {string} actionId Predefined Action ID
     * @param {PredefinedAction} predefinedAction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePredefinedAction(orgId: string, actionId: string, predefinedAction: PredefinedAction, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePredefinedAction(orgId, actionId, predefinedAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates notification preferences for a specific user.
     * @summary Update user preferences
     * @param {string} userId User ID
     * @param {UserPreferences} userPreferences 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPreferences(userId: string, userPreferences: UserPreferences, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPreferences(userId, userPreferences, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a 302 redirect to the assessment access URL for direct browser access
     * @summary Get assessment access URL with redirect
     * @param {string} orgId Organization ID
     * @param {string} enrollmentId Enrollment ID
     * @param {string} assessmentId Assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public viewAssessment(orgId: string, enrollmentId: string, assessmentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).viewAssessment(orgId, enrollmentId, assessmentId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetDashboardEmbedUrlSlugEnum = {
    WorkflowEfficiency: 'workflow-efficiency',
    Technique: 'technique',
    TkaTopic: 'tka-topic',
    UkaTopic: 'uka-topic',
    VppPostOpPatient: 'vpp-post-op-patient'
} as const;
export type GetDashboardEmbedUrlSlugEnum = typeof GetDashboardEmbedUrlSlugEnum[keyof typeof GetDashboardEmbedUrlSlugEnum];
/**
 * @export
 */
export const GetEnrollmentDashboardEmbedUrlSlugEnum = {
    VppPostOpKnee: 'vpp-post-op-knee',
    VppPostOpPatientKnee: 'vpp-post-op-patient-knee',
    VppPostOpHip: 'vpp-post-op-hip',
    VppPostOpPatientHip: 'vpp-post-op-patient-hip',
    VppPostOpShoulder: 'vpp-post-op-shoulder',
    VppPostOpPatientShoulder: 'vpp-post-op-patient-shoulder'
} as const;
export type GetEnrollmentDashboardEmbedUrlSlugEnum = typeof GetEnrollmentDashboardEmbedUrlSlugEnum[keyof typeof GetEnrollmentDashboardEmbedUrlSlugEnum];
/**
 * @export
 */
export const GetPatientEnrollmentActionsStatusEnum = {
    Completed: 'completed',
    Pending: 'pending',
    Confirmed: 'confirmed'
} as const;
export type GetPatientEnrollmentActionsStatusEnum = typeof GetPatientEnrollmentActionsStatusEnum[keyof typeof GetPatientEnrollmentActionsStatusEnum];
/**
 * @export
 */
export const GetSurgeriesProcedureTypeEnum = {
    Tka: 'TKA',
    Uka: 'UKA'
} as const;
export type GetSurgeriesProcedureTypeEnum = typeof GetSurgeriesProcedureTypeEnum[keyof typeof GetSurgeriesProcedureTypeEnum];


